(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2007],{

/***/ 52447:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-event",
      function () {
        return __webpack_require__(46680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 831:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"https://images-prod.forumm.to/3007/_next/static/media/breakout-room.3914e798.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAJ1BMVEX+weL+weH+vuH+vuD+veD+rdn+ptf+oNX+n9T+is3+c8f+csf+R76SzQryAAAAKElEQVR42mPYnjmtmqGkgcOdIeOQTRvDRNNgSQiRcRjIBUssz5xWDQAJ0A0W5WTooAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 21867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51773);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5779);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);





const Card = (param)=>{
    let { children , className , onClick , imgSrc ="" , imgWidth =80 , imgHeight =80 , title ="Card" , selected =false , text , fixedWidth =true , ratio ="aspect-square" , disabled =false , show =true  } = param;
    const { theme , StaticColours  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
    if (!show) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
        className: "flex flex-col items-center text-center px-5 py-5 rounded-md ".concat(className, " ").concat(onClick && !disabled ? "cursor-pointer" : "cursor-not-allowed"),
        style: {
            backgroundColor: disabled ? StaticColours.disabled : selected ? StaticColours.v2.light_blue : theme.foregroundColour,
            ...fixedWidth ? {
                width: "320px"
            } : {}
        },
        onClick: disabled ? undefined : onClick,
        children: [
            title !== "Card" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "text-xl mt-1 mb-5",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!imgSrc,
                className: "flex items-center rounded-md bg-white ".concat(fixedWidth ? "w-full" : "", " h-auto ").concat(ratio),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    className: "w-full h-full ".concat(disabled && "saturate-0"),
                    style: {
                        objectFit: "fill"
                    },
                    src: imgSrc,
                    alt: title,
                    width: imgWidth,
                    height: imgHeight
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!text,
                className: "text-xs break-words pt-4 px-4",
                style: {
                    width: "18rem"
                },
                children: text
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                show: !!children,
                className: "mt-6 text-xl size-full",
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Card);


/***/ }),

/***/ 71766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const useAutosave = (formData)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const hasDataChanged = (dataToCompare)=>{
        if (JSON.stringify(formData) === JSON.stringify(dataToCompare)) return setHasEdited(false);
        return setHasEdited(true);
    };
    const getHasEdited = ()=>window.localStorage.getItem("Forumm_FormEditedState") === "true";
    const setHasEdited = async (val)=>new Promise((res, rej)=>{
            try {
                window.localStorage.setItem("Forumm_FormEditedState", !!val ? "true" : "false");
                res(true);
            } catch (err) {
                console.error(err);
                rej(false);
            }
        });
    //Route change event listener
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleRouteChange = (url)=>{
            if (router.pathname !== url && window.localStorage.getItem("Forumm_FormEditedState") === "true") {
                router.events.emit("routeChangeError", "UNSAVED CONTENT ERROR", url);
                throw "Abort route change. Please ignore this error.";
            }
        };
        const handleRouteError = ()=>{
            console.error("Route change failed");
        };
        /* router.events.on('routeChangeStart', handleRouteChange) */ /* router.events.on('routeChangeError', handleRouteError) */ return ()=>{
        /* router.events.off('routeChangeStart', handleRouteChange) */ /* router.events.off('routeChangeError', handleRouteError) */ };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router
    ]);
    return {
        getHasEdited,
        setHasEdited,
        hasDataChanged
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAutosave);


/***/ }),

/***/ 72799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_Form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26291);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(8193);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39618);
/* harmony import */ var _components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20970);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18860);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25687);
/* harmony import */ var _libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29033);
/* harmony import */ var _components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40296);
/* harmony import */ var react_papaparse__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16798);
/* harmony import */ var _libs_useFileUploader__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11734);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71766);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5779);
/* harmony import */ var _components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(98805);
/* provided dependency */ var process = __webpack_require__(83454);






















var _ENVIRONMENT_NAME;
const environment = (_ENVIRONMENT_NAME = process.env.ENVIRONMENT_NAME) !== null && _ENVIRONMENT_NAME !== void 0 ? _ENVIRONMENT_NAME : "dev";
const isDev = environment === "dev";
const AttendeesForm = (param)=>{
    let { updateInProgress  } = param;
    var ref, ref1, ref2, ref3;
    const { theme  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_19__/* .useTheme */ .Fg)();
    const { formData , setFormData , errors , setErrors  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_10__/* .useEventEditor */ .O)();
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [importedRequiresRegFields, setImportedRequiresRegFields] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [copiedStatus, setCopiedStatus] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [showImportModal, setShowImportModal] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [attendeesModalData, setAttendeesModalData] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(undefined);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)();
    const { profile  } = (0,_libs_Auth_useAuth__WEBPACK_IMPORTED_MODULE_11__/* .useAuth */ .aC)();
    const { attendees , tickets , notifyOrganiser  } = formData !== null && formData !== void 0 ? formData : {};
    const noData = attendees == undefined || (attendees === null || attendees === void 0 ? void 0 : attendees.length) === 0;
    const endDateTime = formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.endDateTime;
    const registrationCloseDateTime = formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.registrationCloseDateTime;
    const isRegistrationClosed = endDateTime && moment__WEBPACK_IMPORTED_MODULE_1___default()().isAfter(endDateTime) || registrationCloseDateTime && moment__WEBPACK_IMPORTED_MODULE_1___default()().isAfter(registrationCloseDateTime);
    const hasTickets = tickets && tickets.length > 0;
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_12__.useEffect)(()=>{
        if (!updateInProgress) {
            setIsLoading(false);
        }
    }, [
        updateInProgress
    ]);
    const { readRemoteFile  } = (0,react_papaparse__WEBPACK_IMPORTED_MODULE_16__/* .usePapaParse */ .vE)();
    const uploadFile = (0,_libs_useFileUploader__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
    var ref4, ref5, ref6, ref7, ref8, ref9;
    const modal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        show: showModal,
        setShow: setShowModal,
        title: "".concat((attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.editIndex) !== undefined ? "Update" : "Add", " Attendee"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_5__/* .Form */ .l, {
            initialFormData: {
                name: (ref4 = attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.name) !== null && ref4 !== void 0 ? ref4 : "",
                email: (ref5 = attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.email) !== null && ref5 !== void 0 ? ref5 : "",
                ticket: (ref6 = attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.ticketTitle) !== null && ref6 !== void 0 ? ref6 : "",
                registrationAnswersRequired: (ref7 = attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.requireRegistrationFields) !== null && ref7 !== void 0 ? ref7 : true,
                editIndex: (ref8 = attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.editIndex) !== null && ref8 !== void 0 ? ref8 : ""
            },
            onSubmit: async (data)=>{
                const { name , email , ticket , registrationAnswersRequired , editIndex  } = data;
                if (email === (profile === null || profile === void 0 ? void 0 : profile.email)) {
                    return "Oops! You are already an attendee by default.";
                }
                let payload = {
                    ...formData,
                    attendees: [
                        ...attendees !== null && attendees !== void 0 ? attendees : []
                    ],
                    notifyOrganiser
                };
                if (!payload.attendees) payload.attendees = [];
                const existingAttendee = editIndex === 0 || editIndex ? payload.attendees[editIndex] : null;
                var ref;
                const newAttendee = {
                    ...existingAttendee !== null && existingAttendee !== void 0 ? existingAttendee : {},
                    name: name !== null && name !== void 0 ? name : "",
                    email: email !== null && email !== void 0 ? email : "",
                    ticketTitle: ticket !== null && ticket !== void 0 ? ticket : "",
                    profileImage: (ref = existingAttendee === null || existingAttendee === void 0 ? void 0 : existingAttendee.profileImage) !== null && ref !== void 0 ? ref : "https://media.istockphoto.com/vectors/male-user-icon-vector-id517998264?k=20&m=517998264&s=612x612&w=0&h=pdEwtkJlZsIoYBVeO2Bo4jJN6lxOuifgjaH8uMIaHTU=",
                    requireRegistrationFields: registrationAnswersRequired
                };
                if (editIndex === 0 || editIndex) payload.attendees[editIndex] = newAttendee;
                else payload.attendees.push(newAttendee);
                setFormData(payload);
                setHasEdited(true);
                setShowModal(false);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                    required: true,
                    label: "Name",
                    setError: errorHandler("tickets"),
                    placeholder: "Taylor Swift",
                    value: attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                    required: true,
                    label: "Email",
                    setError: errorHandler("tickets"),
                    placeholder: "tswift@mail.com",
                    value: attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.email
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_4__/* .DropdownInput */ .f, {
                    label: "Ticket",
                    options: (ref9 = tickets === null || tickets === void 0 ? void 0 : tickets.map((t)=>t.title)) !== null && ref9 !== void 0 ? ref9 : [],
                    required: true,
                    placeholder: "Select a ticket",
                    value: attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.ticketTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__/* .CheckboxInput */ .I, {
                    isProtected: true,
                    className: "bg-transparent rounded text-sm justify-start",
                    border: "",
                    label: "Registration Answers Required",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "mt-2",
                        children: "Attendee is required to provide registration details on entry."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                    isProtected: true,
                    value: attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.editIndex,
                    label: "Edit Index",
                    show: false
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                    className: "my-4",
                    title: "".concat((attendeesModalData === null || attendeesModalData === void 0 ? void 0 : attendeesModalData.editIndex) !== undefined ? "Update" : "Add", " Attendee"),
                    buttonType: "submit"
                })
            ]
        })
    });
    var ref10;
    const importCSVModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        show: showImportModal,
        setShow: setShowImportModal,
        title: "Import Attendees from CSV",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/sample_attendees.csv",
                className: "text-link hover:underline pointer",
                download: true,
                children: "Download Sample CSV"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_5__/* .Form */ .l, {
                clearFormOnSubmit: true,
                onSubmit: async (data)=>{
                    const { csvUpload , ticket  } = data;
                    readRemoteFile(csvUpload, {
                        download: true,
                        complete: (res)=>{
                            const newAttendees = [];
                            const emailHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "email";
                            });
                            const nameHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "name";
                            });
                            if (emailHeaderIndex !== -1) res.data.forEach((newA)=>{
                                var ref;
                                if (!newA[emailHeaderIndex]) return;
                                const emailRef = newA[emailHeaderIndex].toLowerCase();
                                var _nameHeaderIndex;
                                const nameRef = (_nameHeaderIndex = newA[nameHeaderIndex]) !== null && _nameHeaderIndex !== void 0 ? _nameHeaderIndex : "No name on file";
                                if (attendees === null || attendees === void 0 ? void 0 : attendees.find((a)=>a.email === emailRef)) return;
                                if (emailRef === (profile === null || profile === void 0 ? void 0 : (ref = profile.email) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || emailRef === "email") return;
                                newAttendees.push({
                                    name: nameRef,
                                    email: emailRef,
                                    ticketTitle: ticket,
                                    profileImage: "https://media.istockphoto.com/vectors/male-user-icon-vector-id517998264?k=20&m=517998264&s=612x612&w=0&h=pdEwtkJlZsIoYBVeO2Bo4jJN6lxOuifgjaH8uMIaHTU=",
                                    requireRegistrationFields: importedRequiresRegFields
                                });
                            });
                            setFormData({
                                ...formData,
                                attendees: [
                                    ...attendees !== null && attendees !== void 0 ? attendees : [],
                                    ...newAttendees !== null && newAttendees !== void 0 ? newAttendees : []
                                ]
                            });
                            setHasEdited(true);
                            setShowImportModal(false);
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_15__/* .FileInput */ .S, {
                        uploadFile: uploadFile,
                        className: "mt-1",
                        label: "CSV Upload",
                        hint: "Max upload: (200MB).",
                        type: "csv"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_4__/* .DropdownInput */ .f, {
                        label: "Ticket",
                        options: (ref10 = tickets === null || tickets === void 0 ? void 0 : tickets.map((t)=>t.title)) !== null && ref10 !== void 0 ? ref10 : [],
                        required: true,
                        placeholder: "Select a ticket",
                        onChange: ()=>{}
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_7__/* .ToggleInput */ .s, {
                        label: "Require imported attendees to answer registration questions?",
                        centerText: true,
                        options: [
                            "Yes",
                            "No"
                        ],
                        className: "w-full mt-4",
                        callback: (data)=>{
                            setImportedRequiresRegFields(data === "Yes");
                        },
                        selected: importedRequiresRegFields ? 0 : 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                        className: "my-4",
                        title: "Import Attendees",
                        type: "primary",
                        buttonType: "submit"
                    })
                ]
            })
        ]
    });
    var _name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            modal,
            importCSVModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                className: "w-full relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        className: "text-sm mt-6 ",
                        children: [
                            "Use this section to manually add attendees. They’ll then directly receive an email inviting them to sign up and access your event.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                            "Once your event is created you’ll also be able to share an invite link that’ll redirect attendees to the event portal page"
                        ]
                    }),
                    !hasTickets && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-red-500 text-sm",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_21__/* .AiOutlineInfoCircle */ .ocf, {
                                className: "w-4 h-4 float-left mr-2"
                            }),
                            "Please create at least one ticket type before adding attendees to your event."
                        ]
                    }),
                    isRegistrationClosed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "text-red-500 text-xs",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_21__/* .AiOutlineInfoCircle */ .ocf, {
                                className: "w-4 h-4 float-left mr-2"
                            }),
                            "Event registration is closed, and you can’t add any more attendees at this time. If you’d like to include more attendees, please update your event dates."
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        className: "w-full my-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_7__/* .ToggleInput */ .s, {
                                value: notifyOrganiser ? "Enabled" : "Disabled",
                                className: "mb-4 text-sm",
                                options: [
                                    "Enabled",
                                    "Disabled"
                                ],
                                callback: (val)=>{
                                    setFormData({
                                        ...formData,
                                        notifyOrganiser: val === "Enabled"
                                    });
                                },
                                label: "Enable this option to receive an email notification each time an attendee registers for your event, allowing you to stay updated on new registrations.",
                                selected: notifyOrganiser ? 0 : 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_7__/* .ToggleInput */ .s, {
                                value: (formData === null || formData === void 0 ? void 0 : (ref2 = formData.event) === null || ref2 === void 0 ? void 0 : ref2.showAttendeeBox) ? "Enabled" : "Disabled",
                                className: "mb-4 text-sm",
                                options: [
                                    "Enabled",
                                    "Disabled"
                                ],
                                callback: (val)=>{
                                    setFormData({
                                        ...formData,
                                        event: {
                                            ...formData === null || formData === void 0 ? void 0 : formData.event,
                                            showAttendeeBox: val === "Enabled"
                                        }
                                    });
                                },
                                label: "Enable this option to show a list of attendees on the event page.",
                                selected: (formData === null || formData === void 0 ? void 0 : (ref3 = formData.event) === null || ref3 === void 0 ? void 0 : ref3.showAttendeeBox) ? 0 : 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        className: "mt-6 mb-4 flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                onClick: ()=>{
                                    setShowModal(true);
                                    setAttendeesModalData(undefined);
                                },
                                title: "Add Attendee",
                                type: "secondary",
                                size: "small",
                                className: "mr-2",
                                disabled: !!isRegistrationClosed || !hasTickets
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                onClick: ()=>{
                                    setShowImportModal(true);
                                    setAttendeesModalData(undefined);
                                },
                                title: "Import Attendees",
                                type: "secondary",
                                size: "small",
                                className: "mr-1",
                                disabled: !!isRegistrationClosed || !hasTickets
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                onClick: (e)=>{
                                    navigator.clipboard.writeText("https://".concat(isDev && "qa.", "forumm.to/event/").concat(formData === null || formData === void 0 ? void 0 : formData.eventId));
                                    setCopiedStatus(true);
                                    e.preventDefault();
                                },
                                title: copiedStatus ? "URL Copied" : "Copy URL",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Name",
                            "Email",
                            "Ticket",
                            ""
                        ],
                        rows: attendees === null || attendees === void 0 ? void 0 : attendees.map((attendee, index)=>[
                                (_name = attendee.name) !== null && _name !== void 0 ? _name : "Unknown",
                                attendee.email,
                                attendee.ticketTitle,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    disabled: isLoading,
                                    confirmModal: {
                                        title: "Are you sure?",
                                        content: "Are you sure you want to delete this? This cannot be undone."
                                    },
                                    editClicked: ()=>{
                                        var _name;
                                        setAttendeesModalData({
                                            ...attendee,
                                            name: (_name = attendee.name) !== null && _name !== void 0 ? _name : "No name on file",
                                            email: attendee.email,
                                            ticketTitle: attendee.ticketTitle,
                                            editIndex: index
                                        });
                                        setShowModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        setHasEdited(true);
                                        setIsLoading(true);
                                        setFormData({
                                            ...formData,
                                            attendees: attendees.filter((t)=>t.email !== attendee.email)
                                        });
                                    }
                                }, index)
                            ])
                    }),
                    noData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                className: "text-sm mt-8 text-center",
                                children: "No attendees have been added"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
AttendeesForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (AttendeesForm);


/***/ }),

/***/ 42793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40296);
/* harmony import */ var _components_inputs_Form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26291);
/* harmony import */ var _components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33923);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18860);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25687);
/* harmony import */ var _libs_useFileUploader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45672);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _public_images_breakout_room_png__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(831);
/* harmony import */ var _components_base_Text__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40517);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(29033);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71766);


















const BreakoutRoomsForm = ()=>{
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false);
    const { formData , setFormData  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__/* .useEventEditor */ .O)();
    const { breakoutRooms  } = formData !== null && formData !== void 0 ? formData : {};
    const noData = breakoutRooms == undefined || breakoutRooms.length === 0;
    const uploadFile = (0,_libs_useFileUploader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
    const [breakoutModalData, setBreakoutModalData] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(undefined);
    const modal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        show: showModal,
        setShow: setShowModal,
        title: (breakoutModalData === null || breakoutModalData === void 0 ? void 0 : breakoutModalData.editIndex) !== undefined ? "Update Breakout Room" : "Create Breakout Room",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l, {
            initialFormData: breakoutModalData,
            clearFormOnSubmit: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                    required: true,
                    label: "Title",
                    placeholder: "Forumm",
                    value: breakoutModalData === null || breakoutModalData === void 0 ? void 0 : breakoutModalData.title,
                    onChange: (data)=>{
                        setBreakoutModalData({
                            ...breakoutModalData,
                            title: data
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_5__/* .TextAreaInput */ .F, {
                    className: "mt-6",
                    label: "Description",
                    placeholder: "Write your description",
                    value: breakoutModalData === null || breakoutModalData === void 0 ? void 0 : breakoutModalData.description,
                    onChange: (data)=>{
                        setBreakoutModalData({
                            ...breakoutModalData,
                            description: data
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                    label: "Max Attendees",
                    type: "number",
                    required: true,
                    placeholder: "Example: 10",
                    min: 1,
                    max: 30,
                    hint: "Maximum: 30",
                    value: breakoutModalData === null || breakoutModalData === void 0 ? void 0 : breakoutModalData.maxAttendees,
                    onChange: (data)=>{
                        setBreakoutModalData({
                            ...breakoutModalData,
                            maxAttendees: data !== null && data !== void 0 ? data : 1
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_3__/* .FileInput */ .S, {
                    uploadFile: uploadFile,
                    label: "Thumbnail Image",
                    hint: "(Optional) recommended size 500x500px",
                    value: breakoutModalData === null || breakoutModalData === void 0 ? void 0 : breakoutModalData.thumbnailImage,
                    onChange: (data)=>{
                        setBreakoutModalData({
                            ...breakoutModalData,
                            thumbnailImage: data
                        });
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                    className: "my-4",
                    title: (breakoutModalData === null || breakoutModalData === void 0 ? void 0 : breakoutModalData.editIndex) !== undefined ? "Save" : "Create Room",
                    type: "primary",
                    buttonType: "submit",
                    onClick: ()=>{
                        const { title , description , maxAttendees , thumbnailImage , editIndex  } = breakoutModalData !== null && breakoutModalData !== void 0 ? breakoutModalData : [];
                        let payload = {
                            ...formData,
                            breakoutRooms: [
                                ...breakoutRooms !== null && breakoutRooms !== void 0 ? breakoutRooms : []
                            ]
                        };
                        const maxAtt = parseInt(maxAttendees);
                        if (maxAtt > 60) return;
                        const newBreakoutRoom = {
                            title: title,
                            description: description,
                            maxAttendees: maxAtt,
                            thumbnailImage: thumbnailImage
                        };
                        if (!payload.breakoutRooms) payload.breakoutRooms = [];
                        if (editIndex === 0 || editIndex) payload.breakoutRooms[editIndex] = newBreakoutRoom;
                        else payload.breakoutRooms.push(newBreakoutRoom);
                        setFormData(payload);
                        setHasEdited(true);
                        setShowModal(false);
                    }
                })
            ]
        })
    });
    var _maxAttendees;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            modal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "text-xl mb-6",
                        children: noData ? "You have not added any Breakout Rooms." : "".concat(breakoutRooms.length, " Room").concat(breakoutRooms.length > 1 ? "s" : "", " Added")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mb-6",
                        children: "Click add room to add a new Breakout Room."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        onClick: ()=>{
                            setShowModal(true);
                            setBreakoutModalData(undefined);
                        },
                        title: "Add Room",
                        type: "secondary",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: "my-6 border-gray-600 opacity-50"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "text-xl mb-6",
                        children: "Breakout Rooms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        tableHeading: [
                            "",
                            "Name",
                            "Description",
                            "Capacity",
                            ""
                        ],
                        rows: breakoutRooms === null || breakoutRooms === void 0 ? void 0 : breakoutRooms.map((breakoutRoom, index)=>[
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_13___default()), {
                                    src: breakoutRoom.thumbnailImage || _public_images_breakout_room_png__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,
                                    alt: breakoutRoom.title,
                                    className: "w-10 h-10 object-cover rounded hue-rotate-".concat(!breakoutRoom.thumbnailImage && index * 15),
                                    width: 40,
                                    height: 40
                                }, breakoutRoom.title),
                                breakoutRoom.title,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    className: "max-w-sm truncate",
                                    children: breakoutRoom.description
                                }, breakoutRoom.title),
                                (_maxAttendees = breakoutRoom.maxAttendees) !== null && _maxAttendees !== void 0 ? _maxAttendees : 0,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    confirmModal: {
                                        title: "Are you sure?",
                                        content: "Are you sure you want to delete this? This cannot be undone."
                                    },
                                    editClicked: ()=>{
                                        var _thumbnailImage;
                                        setBreakoutModalData({
                                            index: "".concat(index),
                                            title: breakoutRoom.title,
                                            description: breakoutRoom.description,
                                            maxAttendees: "".concat(breakoutRoom.maxAttendees),
                                            thumbnailImage: (_thumbnailImage = breakoutRoom.thumbnailImage) !== null && _thumbnailImage !== void 0 ? _thumbnailImage : "",
                                            editIndex: index
                                        });
                                        setShowModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        setHasEdited(true);
                                        setFormData({
                                            ...formData,
                                            breakoutRooms: breakoutRooms.filter((_, i)=>i !== index)
                                        });
                                    }
                                }, breakoutRoom.title)
                            ])
                    })
                ]
            })
        ]
    });
};
BreakoutRoomsForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (BreakoutRoomsForm);


/***/ }),

/***/ 18989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18860);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29033);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71766);
/* harmony import */ var _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49532);
/* harmony import */ var _components_inputs_RichTextEditor_RichTextEditor__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19460);














const CommunicationsForm = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const [showSocialModal, setShowSocialModal] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [showAnnouncementModal, setShowAnnouncementModal] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const [modalData, setModalData] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)();
    const { formData , setFormData , validationRules  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_7__/* .useEventEditor */ .O)();
    const { communications  } = formData !== null && formData !== void 0 ? formData : {};
    const noSocials = (communications === null || communications === void 0 ? void 0 : communications.socials) == undefined || (communications === null || communications === void 0 ? void 0 : (ref = communications.socials) === null || ref === void 0 ? void 0 : ref.length) === 0;
    const noAnnouncements = (communications === null || communications === void 0 ? void 0 : communications.announcements) == undefined || (communications === null || communications === void 0 ? void 0 : (ref1 = communications.announcements) === null || ref1 === void 0 ? void 0 : ref1.length) === 0;
    const [communicationsModalData, setCommunicationsModalData] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(undefined);
    const addSocialModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        show: showSocialModal,
        setShow: (newShow)=>{
            setShowSocialModal(newShow);
            setCommunicationsModalData(undefined);
        },
        title: "Manage Social Info",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_3__/* .DropdownInput */ .f, {
                label: "Social Platform",
                options: [
                    "Facebook",
                    "Twitter",
                    "Linkedin",
                    "Instagram"
                ],
                required: true,
                placeholder: "Select a social platforms",
                value: communicationsModalData === null || communicationsModalData === void 0 ? void 0 : communicationsModalData.socialPlatform,
                onChange: (data)=>{
                    setCommunicationsModalData({
                        ...communicationsModalData,
                        socialPlatform: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                validations: {
                    minLength: {
                        value: 5,
                        message: "Platform url must be at least 5 character"
                    }
                },
                required: true,
                label: "Platform Url",
                placeholder: "http://www.facebook.com/...",
                value: communicationsModalData === null || communicationsModalData === void 0 ? void 0 : communicationsModalData.platformUrl,
                onChange: (data)=>{
                    setCommunicationsModalData({
                        ...communicationsModalData,
                        platformUrl: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                className: "my-4",
                title: "Manage Social Info",
                type: "primary",
                onClick: ()=>{
                    var ref;
                    const { platformUrl ="" , socialPlatform ="" , editIndex  } = communicationsModalData !== null && communicationsModalData !== void 0 ? communicationsModalData : {};
                    var ref1;
                    let newSocials = [
                        ...(ref1 = formData === null || formData === void 0 ? void 0 : (ref = formData.communications) === null || ref === void 0 ? void 0 : ref.socials) !== null && ref1 !== void 0 ? ref1 : []
                    ];
                    if (editIndex !== undefined) {
                        // Edit existing social info
                        newSocials[editIndex] = {
                            platform: socialPlatform,
                            url: platformUrl
                        };
                    } else {
                        // Add new social info
                        newSocials.push({
                            platform: socialPlatform,
                            url: platformUrl
                        });
                    }
                    setFormData({
                        ...formData,
                        communications: {
                            ...formData === null || formData === void 0 ? void 0 : formData.communications,
                            socials: newSocials
                        }
                    });
                    setHasEdited(true);
                    setShowSocialModal(false);
                    setCommunicationsModalData(undefined);
                }
            })
        ]
    });
    const addAnnouncementModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        show: showAnnouncementModal,
        setShow: setShowAnnouncementModal,
        title: "Manage Announcements",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                validations: {
                    minLength: {
                        value: 2,
                        message: "Announcement title need to be atleast 2 characters long"
                    }
                },
                required: true,
                label: "Title",
                placeholder: "Announcement Title",
                value: communicationsModalData === null || communicationsModalData === void 0 ? void 0 : communicationsModalData.title,
                onChange: (data)=>{
                    setCommunicationsModalData({
                        ...communicationsModalData,
                        title: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_RichTextEditor_RichTextEditor__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                resizeEnabled: true,
                tooltip: "Annountment Body",
                testid: "email-content-input",
                className: "relative max-h-[44vh] flex",
                label: "Announcement Body",
                placeholder: "Write your announcement here",
                value: communicationsModalData === null || communicationsModalData === void 0 ? void 0 : communicationsModalData.body,
                onChange: (res)=>{
                    if (res) setCommunicationsModalData((state)=>({
                            ...state,
                            body: res
                        }));
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                className: "my-4",
                title: "Manage Announcement",
                type: "primary",
                onClick: ()=>{
                    var ref;
                    const { title ="" , body ="" , editIndex  } = communicationsModalData !== null && communicationsModalData !== void 0 ? communicationsModalData : {};
                    var ref1;
                    let newAnnouncements = [
                        ...(ref1 = formData === null || formData === void 0 ? void 0 : (ref = formData.communications) === null || ref === void 0 ? void 0 : ref.announcements) !== null && ref1 !== void 0 ? ref1 : []
                    ];
                    if (editIndex !== undefined) {
                        // Edit existing announcement
                        newAnnouncements[editIndex] = {
                            title,
                            body
                        };
                    } else {
                        // Add new announcement
                        newAnnouncements.push({
                            title,
                            body
                        });
                    }
                    setFormData({
                        ...formData,
                        communications: {
                            ...formData === null || formData === void 0 ? void 0 : formData.communications,
                            announcements: newAnnouncements
                        }
                    });
                    setHasEdited(true);
                    setShowAnnouncementModal(false);
                }
            })
        ]
    });
    var ref6;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            addSocialModal,
            addAnnouncementModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_12__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("communications_socials"))),
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mb-6",
                                children: noSocials ? "No social have been added" : "".concat((ref2 = communications.socials) === null || ref2 === void 0 ? void 0 : ref2.length, " Social Account").concat(((ref6 = (ref3 = communications.socials) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref6 !== void 0 ? ref6 : 0 > 1) ? "s" : "", " Added")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                    onClick: ()=>{
                                        setShowSocialModal(true);
                                        setModalData(undefined);
                                    },
                                    title: "Add Social Info",
                                    type: "secondary",
                                    size: "small"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-xl mb-6",
                                children: "Social Info"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                tableHeading: [
                                    "Platform",
                                    "Url",
                                    ""
                                ],
                                rows: communications === null || communications === void 0 ? void 0 : (ref4 = communications.socials) === null || ref4 === void 0 ? void 0 : ref4.map((social, index)=>{
                                    return [
                                        social.platform,
                                        social.url,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            editClicked: ()=>{
                                                setCommunicationsModalData({
                                                    socialPlatform: social.platform,
                                                    platformUrl: social.url,
                                                    editIndex: index
                                                });
                                                setShowSocialModal(true);
                                            },
                                            deleteClicked: ()=>{
                                                var ref;
                                                setFormData({
                                                    ...formData,
                                                    communications: {
                                                        socials: (ref = communications.socials) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index)
                                                    }
                                                });
                                            }
                                        }, index)
                                    ];
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                show: noSocials,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "text-sm mt-8 text-center",
                                    children: "No social have been added"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: "my-6 border-gray-600 opacity-50"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_12__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("communications_announcements"))),
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-xl mb-6",
                                children: "Announcements"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "mb-6 max-w-2xl",
                                children: "Need to let your attendees know some important information? Create an announcement to show all attendees when they join your event:"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setShowAnnouncementModal(true);
                                    setModalData(undefined);
                                    setCommunicationsModalData(undefined);
                                },
                                title: "Create Announcement",
                                type: "secondary",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-xl mb-6",
                                children: "Announcements"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                tableHeading: [
                                    "Title",
                                    "Info",
                                    ""
                                ],
                                rows: communications === null || communications === void 0 ? void 0 : (ref5 = communications.announcements) === null || ref5 === void 0 ? void 0 : ref5.map((announcement, index)=>{
                                    return [
                                        announcement.title,
                                        announcement.body,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            confirmModal: {
                                                title: "Are you sure?",
                                                content: "Are you sure you want to delete this? This cannot be undone."
                                            },
                                            editClicked: ()=>{
                                                setCommunicationsModalData({
                                                    title: announcement.title,
                                                    body: announcement.body,
                                                    editIndex: index
                                                });
                                                setShowAnnouncementModal(true);
                                            },
                                            deleteClicked: ()=>{
                                                var ref;
                                                setFormData({
                                                    ...formData,
                                                    communications: {
                                                        announcements: communications === null || communications === void 0 ? void 0 : (ref = communications.announcements) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index)
                                                    }
                                                });
                                            }
                                        }, index)
                                    ];
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
CommunicationsForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (CommunicationsForm);


/***/ }),

/***/ 46680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CreateEventPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18860);
/* harmony import */ var _components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47906);
/* harmony import */ var _components_event_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21867);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11390);
/* harmony import */ var react_icons_ci__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(38138);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68240);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98749);
/* harmony import */ var _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49532);
/* harmony import */ var _attendees__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(72799);
/* harmony import */ var _breakout_rooms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42793);
/* harmony import */ var _communications__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18989);
/* harmony import */ var _on_demand__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35355);
/* harmony import */ var _registration_registration__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61433);
/* harmony import */ var _sessions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57325);
/* harmony import */ var _speakers__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54212);
/* harmony import */ var _sponsors__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10942);
/* harmony import */ var _stages__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23906);
/* harmony import */ var _components_base_Text__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(40517);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(89583);
/* harmony import */ var _components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(98805);
/* harmony import */ var _notifications__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(97150);
/* harmony import */ var _details__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(75250);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(25687);


























function CreateEventPage() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    const { activeEventId , completeSections , createEventStage , errors , eventTypeError , formData , formState , goToDashboard , handleNext , handleSelectEventType , handleZapierAttendeeSync , isAdmin , isLoading , isZapierSyncing , organisationProfile , perms , saved , setShowErrorModal , showErrorModal , toggleFundraising , togglePremium , urlEventId , validationRules , zapierSyncMessage  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_23__/* .useEventEditor */ .O)();
    if ((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Type */ .M.Type || !urlEventId && !(formData === null || formData === void 0 ? void 0 : formData.eventId) && (formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType) === undefined) {
        var ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
            className: "flex flex-col items-center mx-auto",
            style: {
                width: "90%"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    className: "text-2xl my-2",
                    children: "Create your event"
                }),
                eventTypeError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    ignoreTheme: true,
                    className: "mb-4 text-sm font-semibold text-red-600",
                    children: eventTypeError
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex flex-row justify-evenly space-x-2 overflow-x-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_event_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            selected: (formData === null || formData === void 0 ? void 0 : (ref16 = formData.event) === null || ref16 === void 0 ? void 0 : ref16.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Online */ .tw.Online,
                            imgSrc: "/images/onlineEvent.svg",
                            imgWidth: 200,
                            imgHeight: 200,
                            onClick: ()=>handleSelectEventType(_graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Online */ .tw.Online),
                            disabled: isLoading,
                            text: "Create online events and engage with your audience all around the world.",
                            // disabled={!isAdmin && !perms.find((p) => p === 'ONLINE')}
                            title: "Online Event",
                            show: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__/* .CheckboxInput */ .I, {
                                    isProtected: true,
                                    value: formData === null || formData === void 0 ? void 0 : (ref17 = formData.fundraising) === null || ref17 === void 0 ? void 0 : ref17.enabled,
                                    onChange: (val)=>{
                                        toggleFundraising(val);
                                    },
                                    show: (isAdmin || !!perms.find((p)=>p === "FUNDRAISER")) && (formData === null || formData === void 0 ? void 0 : (ref18 = formData.event) === null || ref18 === void 0 ? void 0 : ref18.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Online */ .tw.Online,
                                    className: "bg-transparent rounded text-sm border-box -mt-1",
                                    border: "",
                                    label: "Additional Tickets",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mt-2",
                                        children: "Enable Fundraising"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__/* .CheckboxInput */ .I, {
                                    isProtected: true,
                                    value: formData === null || formData === void 0 ? void 0 : formData.isPremium,
                                    onChange: (val)=>{
                                        togglePremium(val);
                                    },
                                    show: (isAdmin || !!perms.find((p)=>p === "PREMIUM")) && (formData === null || formData === void 0 ? void 0 : (ref19 = formData.event) === null || ref19 === void 0 ? void 0 : ref19.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Online */ .tw.Online,
                                    className: "bg-transparent rounded text-sm border-box -mt-1",
                                    border: "",
                                    label: "Additional Tickets",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mt-2",
                                        children: "Premium Event"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_event_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            selected: (formData === null || formData === void 0 ? void 0 : (ref20 = formData.event) === null || ref20 === void 0 ? void 0 : ref20.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.InPerson */ .tw.InPerson,
                            imgSrc: "/images/inpersonEvent.svg",
                            imgWidth: 200,
                            imgHeight: 200,
                            onClick: ()=>{
                                handleSelectEventType(_graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.InPerson */ .tw.InPerson);
                            },
                            disabled: isLoading,
                            text: "",
                            title: "Click to begin",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__/* .CheckboxInput */ .I, {
                                    isProtected: true,
                                    value: formData === null || formData === void 0 ? void 0 : (ref21 = formData.fundraising) === null || ref21 === void 0 ? void 0 : ref21.enabled,
                                    onChange: (val)=>{
                                        toggleFundraising(val);
                                    },
                                    // show={
                                    //   (isAdmin || !!perms.find((p) => p === 'FUNDRAISER')) &&
                                    //   formData?.event?.eventType === EventType.InPerson
                                    // }
                                    //
                                    show: false,
                                    className: "bg-transparent rounded text-sm border-box -mt-1 flex-",
                                    border: "",
                                    label: "Additional Tickets",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mt-2",
                                        children: "Enable Fundraising"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_CheckboxInput__WEBPACK_IMPORTED_MODULE_20__/* .CheckboxInput */ .I, {
                                    isProtected: true,
                                    value: formData === null || formData === void 0 ? void 0 : formData.isPremium,
                                    onChange: (val)=>{
                                        togglePremium(val);
                                    },
                                    show: (isAdmin || !!perms.find((p)=>p === "PREMIUM")) && (formData === null || formData === void 0 ? void 0 : (ref22 = formData.event) === null || ref22 === void 0 ? void 0 : ref22.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.InPerson */ .tw.InPerson,
                                    className: "bg-transparent rounded text-sm border-box -mt-1",
                                    border: "",
                                    label: "Additional Tickets",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mt-2",
                                        children: "Premium Event"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Card__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            selected: (formData === null || formData === void 0 ? void 0 : (ref23 = formData.event) === null || ref23 === void 0 ? void 0 : ref23.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Fundraiser */ .tw.Fundraiser,
                            imgSrc: "/images/fundraisingOnly.svg",
                            imgWidth: 200,
                            imgHeight: 200,
                            onClick: ()=>handleSelectEventType(_graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Fundraiser */ .tw.Fundraiser),
                            text: "Create fundraisers and achieve your goals",
                            disabled: isLoading || !isAdmin && !perms.find((p)=>p === "FUNDRAISER"),
                            title: "Fundraising Only",
                            show: false
                        })
                    ]
                })
            ]
        });
    }
    var ref24;
    const internalLocationsOptions = ((ref24 = organisationProfile === null || organisationProfile === void 0 ? void 0 : organisationProfile.locations) !== null && ref24 !== void 0 ? ref24 : []).map((loc)=>({
            label: loc,
            value: loc
        }));
    const error_modal = ()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            title: "Editor Error",
            show: showErrorModal,
            setShow: setShowErrorModal,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex items-center justify-center pb-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "flex items-center justify-center p-2 bg-red-50 rounded-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ci__WEBPACK_IMPORTED_MODULE_24__/* .CiWarning */ .XvE, {
                            className: "w-10 h-10"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold mb-2",
                    children: "There was an issue editing the event."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold text-md",
                    children: "Section: "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "font-bold text-md",
                    children: "Error: "
                })
            ]
        });
    };
    var ref25;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: "flex flex-col space-y-6 ".concat((createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Preview */ .M.Preview && "h-screen"),
        children: [
            error_modal(),
            errors && errors.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "transition-all text-red-500 text-lg font-bold",
                children: "Please complete all required sections."
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                show: saved,
                className: "flex items-center justify-end text-forumm-green animate-pulse sticky top-[20px]",
                ignoreTheme: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_25__/* .FaRegCheckCircle */ .wO, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        ignoreTheme: true,
                        className: "ml-2",
                        children: "Event saved."
                    })
                ]
            }),
            (createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Details */ .M.Details ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.DETAILS */ .nA.DETAILS,
                        title: (formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Fundraiser */ .tw.Fundraiser ? "Fundraising Page" : "Event",
                        initiallyOpen: true,
                        error: (ref2 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "event")) === null || ref2 === void 0 ? void 0 : ref2.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("event"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_details__WEBPACK_IMPORTED_MODULE_22__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        title: "Registration",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.REGISTRATION */ .nA.REGISTRATION,
                        initiallyOpen: formState.registration,
                        error: (ref3 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "tickets")) === null || ref3 === void 0 ? void 0 : ref3.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("tickets"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_registration_registration__WEBPACK_IMPORTED_MODULE_14__["default"], {
                            currency: organisationProfile.currency
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        title: "Speakers",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.SPEAKERS */ .nA.SPEAKERS,
                        initiallyOpen: formState.speakers,
                        error: (ref4 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "speakers")) === null || ref4 === void 0 ? void 0 : ref4.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("speakers"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_speakers__WEBPACK_IMPORTED_MODULE_16__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        title: "Stages",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.STAGES */ .nA.STAGES,
                        initiallyOpen: formState.stages,
                        error: (ref5 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "stages")) === null || ref5 === void 0 ? void 0 : ref5.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("stages"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_stages__WEBPACK_IMPORTED_MODULE_18__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        title: "Session",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.SESSIONS */ .nA.SESSIONS,
                        initiallyOpen: formState.sessions,
                        error: (ref6 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "sessions")) === null || ref6 === void 0 ? void 0 : ref6.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("sessions"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sessions__WEBPACK_IMPORTED_MODULE_15__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        title: "Attendees",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.ATTENDEES */ .nA.ATTENDEES,
                        initiallyOpen: formState.attendees,
                        error: (ref7 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "attendees")) === null || ref7 === void 0 ? void 0 : ref7.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("attendees"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_attendees__WEBPACK_IMPORTED_MODULE_10__["default"], {
                            updateInProgress: isLoading
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "mt-6",
                        title: "Partners",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.PARTNERS */ .nA.PARTNERS,
                        initiallyOpen: formState.sponsors,
                        error: (ref8 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "sponsors")) === null || ref8 === void 0 ? void 0 : ref8.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("sponsors"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sponsors__WEBPACK_IMPORTED_MODULE_17__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: "Communications",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.COMMUNICATIONS */ .nA.COMMUNICATIONS,
                        className: "mt-6",
                        initiallyOpen: formState.communications,
                        error: (ref9 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "communications")) === null || ref9 === void 0 ? void 0 : ref9.message,
                        show: (formData === null || formData === void 0 ? void 0 : (ref10 = formData.event) === null || ref10 === void 0 ? void 0 : ref10.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .EventType.Fundraiser */ .tw.Fundraiser && (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("communications"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_communications__WEBPACK_IMPORTED_MODULE_12__["default"], {})
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            (createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Communications */ .M.Communications ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: "Breakout",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.BREAKOUT_ROOMS */ .nA.BREAKOUT_ROOMS,
                        className: "mt-6",
                        initiallyOpen: formState.breakoutRooms,
                        error: (ref11 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "breakoutRooms")) === null || ref11 === void 0 ? void 0 : ref11.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("breakoutRooms"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_breakout_rooms__WEBPACK_IMPORTED_MODULE_11__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: "Communications",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.COMMUNICATIONS */ .nA.COMMUNICATIONS,
                        className: "mt-6",
                        initiallyOpen: formState.communications,
                        error: (ref12 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "communications")) === null || ref12 === void 0 ? void 0 : ref12.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("communications"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_communications__WEBPACK_IMPORTED_MODULE_12__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: "Event Emails",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.NOTIFICATIONS */ .nA.NOTIFICATIONS,
                        className: "mt-6",
                        initiallyOpen: formState.notifications,
                        error: (ref13 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "notifications")) === null || ref13 === void 0 ? void 0 : ref13.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("notifications"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_notifications__WEBPACK_IMPORTED_MODULE_21__["default"], {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: "On - Demand",
                        section: _libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .CreateEventSection.ON_DEMAND_CONTENT */ .nA.ON_DEMAND_CONTENT,
                        className: "mt-6",
                        initiallyOpen: formState.onDemand,
                        error: (ref14 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "ondemandContent")) === null || ref14 === void 0 ? void 0 : ref14.message,
                        show: (0,_libs_Utility_validation__WEBPACK_IMPORTED_MODULE_9__/* .shouldShowField */ .f5)(validationRules.find((f)=>f[0].includes("ondemandContent"))),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_on_demand__WEBPACK_IMPORTED_MODULE_13__["default"], {})
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            (createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Preview */ .M.Preview ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "lg:block w-full relative h-full border-forumm-menu-border",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        ignoreTheme: true,
                        className: "text-md absolute p-2 bg-white rounded text-black opacity-60",
                        children: "Preview"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                        className: "w-full h-full rounded border border-white border-solid border-opacity-25 ",
                        onClick: (e)=>{
                            e.preventDefault();
                        },
                        /* src={`/donation/${formData?.event?.donationUrl}`} */ src: "/event/".concat(formData === null || formData === void 0 ? void 0 : formData.eventId, "/agenda?preview=true&r=").concat(Math.random())
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
            activeEventId && ((ref25 = formData === null || formData === void 0 ? void 0 : (ref15 = formData.attendees) === null || ref15 === void 0 ? void 0 : ref15.length) !== null && ref25 !== void 0 ? ref25 : 0) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "mt-6 flex flex-col items-end gap-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                        title: "Sync attendees with Zapier",
                        type: "secondary",
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_25__/* .FaSyncAlt */ .dnK, {}),
                        loading: isZapierSyncing || isLoading,
                        disabled: isZapierSyncing || isLoading,
                        onClick: handleZapierAttendeeSync,
                        size: "small",
                        confirmationModal: {
                            title: "Sync attendees with Zapier",
                            content: "This sends every current attendee on this event to active Zapier hooks."
                        }
                    }),
                    zapierSyncMessage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Text__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        ignoreTheme: true,
                        className: "text-sm text-forumm-green",
                        children: zapierSyncMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "mt-6 ml-auto flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                        title: "Back to dashboard",
                        type: "secondary",
                        textColor: "#3763e9",
                        onClick: goToDashboard,
                        size: "small"
                    }),
                    completeSections.details && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                        "data-testid": "submit-button",
                        className: "ml-2",
                        title: (createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Preview */ .M.Preview ? "Finish" : (createEventStage === null || createEventStage === void 0 ? void 0 : createEventStage.stage) === _libs_CreateEvent_CreateEventStage__WEBPACK_IMPORTED_MODULE_8__/* .CreateEventStage.Communications */ .M.Communications && createEventStage.skipPreview ? "Finish" : "Save & Next",
                        buttonType: "submit",
                        onClick: handleNext,
                        size: "small"
                    })
                ]
            })
        ]
    });
}
CreateEventPage.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;


/***/ }),

/***/ 97150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ notifications; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./layouts/CreateEventLayout.tsx + 6 modules
var CreateEventLayout = __webpack_require__(67526);
// EXTERNAL MODULE: ./libs/CreateEvent/useEventEditor.tsx + 6 modules
var useEventEditor = __webpack_require__(25687);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/base/Table.tsx
var Table = __webpack_require__(45672);
// EXTERNAL MODULE: ./components/event/TableRowActions.tsx
var TableRowActions = __webpack_require__(29033);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/email-builder/index.tsx
var email_builder = __webpack_require__(79656);
// EXTERNAL MODULE: ./components/email-builder/emailbuilder.type.ts
var emailbuilder_type = __webpack_require__(88378);
// EXTERNAL MODULE: ./components/email-builder/emailPreview.tsx + 1 modules
var emailPreview = __webpack_require__(51062);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/events/triggerEmailEvent.ts

const TRIGGER_EVENT_EMAIL = (0,_generated/* graphql */.B)("\n  mutation triggerEventEmail($eventId: String!, $template: String!) {\n    triggerEventEmail(eventId: $eventId, emailTemplate: $template)\n  }\n");

;// CONCATENATED MODULE: ./libs/CreateEvent/emailScheduling.ts
var ref;
const normalizedTitle = (title)=>{
    return (ref = title === null || title === void 0 ? void 0 : title.trim().toLowerCase()) !== null && ref !== void 0 ? ref : "";
};
/**
 * Compatibility only for schedules created before schedules were embedded in
 * email templates. New schedules must never use title as identity.
 */ const findLegacyEmailSchedule = (notifications, templateTitle)=>{
    const title = normalizedTitle(templateTitle);
    if (!title) return undefined;
    return notifications === null || notifications === void 0 ? void 0 : notifications.find((notification)=>normalizedTitle(notification.title) === title);
};
const removeLegacyEmailSchedule = (param)=>{
    let { notifications =[] , templateTitle , timestamp  } = param;
    const title = normalizedTitle(templateTitle);
    if (!title && !timestamp) return [
        ...notifications !== null && notifications !== void 0 ? notifications : []
    ];
    return (notifications !== null && notifications !== void 0 ? notifications : []).filter((notification)=>!(normalizedTitle(notification.title) === title && (!timestamp || notification.timestamp === timestamp)));
};

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./pages/create-event/notifications.tsx


















const NotificationsForm = ()=>{
    var ref, ref1;
    const { formData , setFormData , errors , setErrors , refetchEvent  } = (0,useEventEditor/* useEventEditor */.O)();
    const [showEmailModal, setShowEmailModal] = (0,react.useState)(false);
    const [triggerMail] = (0,useMutation/* useMutation */.D)(TRIGGER_EVENT_EMAIL);
    const [emailModalData, setEmailModalData] = (0,react.useState)({});
    // const [errors, setErrors] = useState<ErrorType | undefined>(undefined)
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    const emailBuilderModal = (0,react.useMemo)(()=>{
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showEmailModal,
            setShow: setShowEmailModal,
            title: "".concat((emailModalData === null || emailModalData === void 0 ? void 0 : emailModalData.editIndex) !== undefined || emailModalData.editIndex === 0 ? "Edit" : "Create", " Email"),
            className: "flex overflow-visible w-full flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(email_builder/* default */.ZP, {
                    onSubmit: (data)=>{
                        console.log({
                            data
                        });
                        setEmailModalData(data);
                    },
                    enablePreview: true,
                    setError: errorHandler("email_builder"),
                    template: emailModalData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "mb-4 ml-auto",
                    title: emailModalData.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q ? "Schedule Email" : "Save Email",
                    type: "primary",
                    disabled: emailModalData.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q && (!((ref = emailModalData.schedule) === null || ref === void 0 ? void 0 : ref.runAt) || !moment_default()(emailModalData.schedule.runAt).isAfter(moment_default()())),
                    onClick: (e)=>{
                        var ref;
                        e.preventDefault();
                        console.log({
                            templates: formData === null || formData === void 0 ? void 0 : formData.emailTemplates,
                            emailModalData
                        });
                        var ref1;
                        let payload = {
                            ...formData,
                            emailTemplates: [
                                ...(ref1 = formData === null || formData === void 0 ? void 0 : formData.emailTemplates) !== null && ref1 !== void 0 ? ref1 : []
                            ]
                        };
                        const hasRegistrationConfirmationTemplate = !!(payload === null || payload === void 0 ? void 0 : (ref = payload.emailTemplates) === null || ref === void 0 ? void 0 : ref.find((f)=>f.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation));
                        const newEmail = {
                            templateId: emailModalData.templateId || (0,v4/* default */.Z)(),
                            title: emailModalData.title,
                            enabled: true,
                            trigger: emailModalData.trigger,
                            data: emailModalData.data,
                            content: emailModalData.content,
                            schedule: emailModalData.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q ? emailModalData.schedule : undefined
                        };
                        if (!payload.emailTemplates) payload.emailTemplates = [];
                        if (newEmail.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation && hasRegistrationConfirmationTemplate) payload = {
                            ...payload,
                            emailTemplates: [
                                ...payload.emailTemplates.map((template)=>template.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation ? {
                                        ...template,
                                        trigger: graphql/* EventEmailTrigger.Manual */.bQ.Manual
                                    } : template)
                            ]
                        };
                        if (!!payload.emailTemplates) {
                            if (emailModalData.editIndex === 0 || emailModalData.editIndex) payload.emailTemplates[emailModalData.editIndex] = newEmail;
                            else payload.emailTemplates.push(newEmail);
                        }
                        if (emailModalData.legacyScheduleTimestamp) payload.notifications = removeLegacyEmailSchedule({
                            notifications: payload.notifications,
                            templateTitle: emailModalData.originalTitle,
                            timestamp: emailModalData.legacyScheduleTimestamp
                        });
                        console.log({
                            payload
                        });
                        setFormData(payload);
                        (0,email_builder/* clearEmailContentCache */.ok)({
                            type: "event",
                            scopeId: formData === null || formData === void 0 ? void 0 : formData.eventId,
                            template: emailModalData
                        });
                        setShowEmailModal(false);
                        setEmailModalData({});
                    }
                })
            ]
        });
    }, [
        formData,
        showEmailModal,
        emailModalData
    ]);
    const [actionLoading, setActionLoading] = (0,react.useState)(false);
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            emailBuilderModal,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "size-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex items-center space-x-2 mb-4 mt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-xl",
                                children: "Emails"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: ()=>{
                                    var ref, ref1;
                                    var ref2, ref3;
                                    setEmailModalData({
                                        title: "Email Template ".concat((ref2 = formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1),
                                        trigger: ((ref3 = formData === null || formData === void 0 ? void 0 : (ref1 = formData.emailTemplates) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref3 !== void 0 ? ref3 : 0) > 0 ? graphql/* EventEmailTrigger.Manual */.bQ.Manual : graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation
                                    });
                                    setShowEmailModal(true);
                                },
                                title: "Create New Email",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                        sortable: true,
                        items: (ref2 = formData === null || formData === void 0 ? void 0 : formData.emailTemplates) !== null && ref2 !== void 0 ? ref2 : undefined,
                        onSort: (e)=>{
                            console.log({
                                e
                            });
                            const payload = {
                                ...formData,
                                emailTemplates: e
                            };
                            setFormData(payload);
                        },
                        tableHeading: [
                            "Subject",
                            "Delivery",
                            "Status / time",
                            ""
                        ],
                        rows: formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.map((emailTemplates, index)=>{
                            var ref, ref1, ref2;
                            const legacySchedule = emailTemplates.schedule ? undefined : findLegacyEmailSchedule(formData.notifications, emailTemplates.title);
                            var ref3;
                            const scheduleStatus = (ref3 = (ref = emailTemplates.schedule) === null || ref === void 0 ? void 0 : ref.status) !== null && ref3 !== void 0 ? ref3 : legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.status;
                            var ref4;
                            const scheduledAt = (ref4 = (ref1 = emailTemplates.schedule) === null || ref1 === void 0 ? void 0 : ref1.runAt) !== null && ref4 !== void 0 ? ref4 : legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.timestamp;
                            const isScheduled = emailTemplates.trigger === emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q && !!emailTemplates.schedule || !!legacySchedule;
                            var ref5;
                            return [
                                (ref5 = emailTemplates === null || emailTemplates === void 0 ? void 0 : (ref2 = emailTemplates.title) === null || ref2 === void 0 ? void 0 : ref2.toUpperCase()) !== null && ref5 !== void 0 ? ref5 : "No Title (".concat(index, ")"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "rounded-md capitalize",
                                    children: isScheduled ? "Scheduled send" : emailTemplates.trigger
                                }, "notification-delivery-".concat(index)),
                                isScheduled ? "".concat(scheduleStatus === graphql/* NotificationStatus.Sent */.Ez.Sent ? "Sent" : scheduleStatus === graphql/* NotificationStatus.Failed */.Ez.Failed ? "Failed" : "Scheduled for", " ").concat(moment_default()(scheduledAt).format("D MMMM YYYY, h:mm A")) : emailTemplates.sentDateTime ? moment_default()(emailTemplates.sentDateTime).format("D MMMM YYYY, h:mm A").toString() : emailTemplates.trigger === graphql/* EventEmailTrigger.Manual */.bQ.Manual ? "Not sent" : "On registration",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowActions/* default */.Z, {
                                    action: [
                                        {
                                            title: "Send",
                                            show: emailTemplates.trigger === graphql/* EventEmailTrigger.Manual */.bQ.Manual && !isScheduled,
                                            loading: actionLoading,
                                            onClicked: ()=>{
                                                if (!!formData.eventId && !!emailTemplates.title) {
                                                    setActionLoading(true);
                                                    triggerMail({
                                                        variables: {
                                                            eventId: formData.eventId,
                                                            template: emailTemplates.title
                                                        }
                                                    }).then(()=>{
                                                        refetchEvent();
                                                    }).finally(()=>setActionLoading(false));
                                                }
                                            },
                                            confirmModal: {
                                                title: "Are you sure?",
                                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "pt-6 pb-6",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "my-2 mb-6",
                                                            children: "Are you sure you want to send this email to all attendees? Please ensure your email template is correct before confirming."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "h-[50vh]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(emailPreview/* EmailPreview */.M, {
                                                                resizeEnabled: false,
                                                                content: emailTemplates.content
                                                            })
                                                        })
                                                    ]
                                                })
                                            }
                                        },
                                        {
                                            title: "Duplicate",
                                            show: emailTemplates.trigger !== graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation,
                                            loading: actionLoading,
                                            onClicked: ()=>{
                                                if (!!formData.eventId && !!emailTemplates.title) {
                                                    var ref;
                                                    setActionLoading(true);
                                                    const targetTemplate = (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.find((f)=>f.title === emailTemplates.title);
                                                    if (targetTemplate) {
                                                        const { templateId: _templateId , schedule: _schedule , ...templateCopy } = targetTemplate;
                                                        var _emailTemplates;
                                                        setFormData({
                                                            ...formData,
                                                            emailTemplates: [
                                                                ...(_emailTemplates = formData.emailTemplates) !== null && _emailTemplates !== void 0 ? _emailTemplates : [],
                                                                {
                                                                    ...templateCopy,
                                                                    title: "".concat(targetTemplate.title, " - Copy"),
                                                                    trigger: graphql/* EventEmailTrigger.Manual */.bQ.Manual
                                                                }
                                                            ]
                                                        });
                                                    }
                                                    setActionLoading(false);
                                                }
                                            }
                                        }
                                    ],
                                    editClicked: ()=>{
                                        console.log({
                                            emailTemplates,
                                            index
                                        });
                                        var _trigger, _status, _schedule, _title, ref;
                                        setEmailModalData({
                                            ...emailTemplates,
                                            editIndex: index,
                                            trigger: isScheduled ? emailbuilder_type/* SCHEDULED_EMAIL_TRIGGER */.Q : (_trigger = emailTemplates.trigger) !== null && _trigger !== void 0 ? _trigger : graphql/* EventEmailTrigger.Manual */.bQ.Manual,
                                            schedule: (_schedule = emailTemplates.schedule) !== null && _schedule !== void 0 ? _schedule : legacySchedule && scheduledAt ? {
                                                scheduleId: "",
                                                runAt: scheduledAt,
                                                status: (_status = legacySchedule.status) !== null && _status !== void 0 ? _status : graphql/* NotificationStatus.Processing */.Ez.Processing
                                            } : undefined,
                                            originalTitle: legacySchedule ? (_title = emailTemplates.title) !== null && _title !== void 0 ? _title : undefined : undefined,
                                            legacyScheduleTimestamp: (ref = legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.timestamp) !== null && ref !== void 0 ? ref : undefined
                                        });
                                        setShowEmailModal(true);
                                    },
                                    deleteClicked: emailTemplates.trigger !== graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation ? ()=>{
                                        var ref;
                                        setFormData({
                                            ...formData,
                                            emailTemplates: formData === null || formData === void 0 ? void 0 : (ref = formData.emailTemplates) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index),
                                            notifications: removeLegacyEmailSchedule({
                                                notifications: formData.notifications,
                                                templateTitle: emailTemplates.title,
                                                timestamp: legacySchedule === null || legacySchedule === void 0 ? void 0 : legacySchedule.timestamp
                                            })
                                        });
                                    } : undefined
                                }, index)
                            ];
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        show: (formData === null || formData === void 0 ? void 0 : (ref1 = formData.emailTemplates) === null || ref1 === void 0 ? void 0 : ref1.length) === 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-sm mt-8 text-center mb-8",
                            children: "No event emails have been created yet"
                        })
                    })
                ]
            })
        ]
    });
};
NotificationsForm.Layout = CreateEventLayout/* default */.Z;
/* harmony default export */ var notifications = (NotificationsForm);


/***/ }),

/***/ 35355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18860);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29033);
/* harmony import */ var _components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40296);
/* harmony import */ var _libs_useFileUploader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11734);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57632);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71766);














const OndemandContantForm = ()=>{
    const [showOndemandContentModal, setShowOndemandContentModal] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false);
    const [modalData, setModalData] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)();
    const { formData , setFormData  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_6__/* .useEventEditor */ .O)();
    const { ondemandContent  } = formData !== null && formData !== void 0 ? formData : {};
    const noMedia = ondemandContent == undefined || (ondemandContent === null || ondemandContent === void 0 ? void 0 : ondemandContent.length) === 0;
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    const uploadFile = (0,_libs_useFileUploader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const [onDemandModalData, setOnDemandModalData] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(undefined);
    const MediaRenderer = (param)=>{
        let { url  } = param;
        const [isVideo, setIsVideo] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(true);
        return isVideo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
            width: 128,
            height: 72,
            src: url,
            onError: ()=>setIsVideo(false),
            controls: true
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: url,
            width: 128,
            height: 72,
            alt: "media content",
            onError: ()=>console.error("Media failed to load as an image as well.")
        });
    };
    const ondemandContentModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        show: showOndemandContentModal,
        setShow: (visible)=>{
            setOnDemandModalData(undefined);
            setShowOndemandContentModal(visible);
        },
        title: "Upload Ondemand Content",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S, {
                className: "mt-8",
                uploadFile: uploadFile,
                label: "Media Input",
                hint: "Max upload: (200MB).",
                value: onDemandModalData === null || onDemandModalData === void 0 ? void 0 : onDemandModalData.mediaInput,
                onChange: (data)=>{
                    setOnDemandModalData({
                        ...onDemandModalData,
                        mediaInput: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, {
                validations: {
                    minLength: {
                        value: 2,
                        message: "Media title must be at least 2 character"
                    }
                },
                required: true,
                label: "Media Title",
                placeholder: "Content title",
                value: onDemandModalData === null || onDemandModalData === void 0 ? void 0 : onDemandModalData.mediaTitle,
                onChange: (data)=>{
                    setOnDemandModalData({
                        ...onDemandModalData,
                        mediaTitle: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, {
                validations: {
                    minLength: {
                        value: 2,
                        message: "Media description must be at least 2 character"
                    }
                },
                required: true,
                label: "Media Description",
                placeholder: "Content description",
                value: onDemandModalData === null || onDemandModalData === void 0 ? void 0 : onDemandModalData.mediaDescription,
                onChange: (data)=>{
                    setOnDemandModalData({
                        ...onDemandModalData,
                        mediaDescription: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_3__/* .TextInput */ .o, {
                validations: {
                    isURL: true
                },
                label: "Url",
                placeholder: "https://youtube.com/....",
                value: onDemandModalData === null || onDemandModalData === void 0 ? void 0 : onDemandModalData.url,
                onChange: (data)=>{
                    setOnDemandModalData({
                        ...onDemandModalData,
                        url: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                className: "my-4",
                title: "".concat(modalData ? "Update" : "Upload", " Content"),
                type: "primary",
                onClick: ()=>{
                    const { mediaTitle , mediaDescription , mediaInput , url , editIndex , id  } = onDemandModalData !== null && onDemandModalData !== void 0 ? onDemandModalData : [];
                    let payload = {
                        ...formData,
                        ondemandContent: [
                            ...ondemandContent !== null && ondemandContent !== void 0 ? ondemandContent : []
                        ]
                    };
                    let newODC = {
                        id: id !== null && id !== void 0 ? id : (0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(),
                        title: mediaTitle !== null && mediaTitle !== void 0 ? mediaTitle : "",
                        description: mediaDescription !== null && mediaDescription !== void 0 ? mediaDescription : "",
                        url: mediaInput !== null && mediaInput !== void 0 ? mediaInput : url
                    };
                    if (editIndex === undefined) payload.ondemandContent.push(newODC);
                    if (editIndex !== undefined) payload.ondemandContent[editIndex] = newODC;
                    setFormData(payload);
                    setHasEdited(true);
                    setShowOndemandContentModal(false);
                    setOnDemandModalData(undefined);
                }
            })
        ]
    });
    var _title, _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            ondemandContentModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mb-6 max-w-2xl",
                        children: "Want to provide attendees with some additional content? Upload ondemand content here for all attendees to view."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            onClick: ()=>{
                                setShowOndemandContentModal(true);
                                setModalData(undefined);
                            },
                            title: "Upload Media",
                            type: "secondary",
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: "my-6 border-gray-600 opacity-50"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "text-xl mb-6",
                        children: "On-demand Content"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Media",
                            "Title",
                            "Description",
                            ""
                        ],
                        rows: ondemandContent === null || ondemandContent === void 0 ? void 0 : ondemandContent.map((content, index)=>[
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MediaRenderer, {
                                    url: content.url
                                }, content.id),
                                (_title = content.title) !== null && _title !== void 0 ? _title : "Title",
                                (_description = content.description) !== null && _description !== void 0 ? _description : "Description",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    confirmModal: {
                                        title: "Are you sure?",
                                        content: "Are you sure you want to delete this? This cannot be undone."
                                    },
                                    editClicked: ()=>{
                                        var _id, _title, _description, _url;
                                        setOnDemandModalData({
                                            id: (_id = content.id) !== null && _id !== void 0 ? _id : "",
                                            mediaTitle: (_title = content.title) !== null && _title !== void 0 ? _title : "",
                                            mediaDescription: (_description = content.description) !== null && _description !== void 0 ? _description : "",
                                            url: (_url = content.url) !== null && _url !== void 0 ? _url : "",
                                            editIndex: index
                                        });
                                        setShowOndemandContentModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        setHasEdited(true);
                                        setFormData({
                                            ...formData,
                                            ondemandContent: ondemandContent.filter((c)=>content.id !== c.id)
                                        });
                                    }
                                }, index)
                            ])
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        show: noMedia,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            className: "text-sm mt-8 text-center",
                            children: "No ondemand content have been created"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                        className: "my-6 border-gray-600 opacity-50"
                    })
                ]
            })
        ]
    });
};
OndemandContantForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (OndemandContantForm);


/***/ }),

/***/ 57325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8194);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33923);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18860);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68240);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29033);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _components_inputs_ArrayTextInput__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(12341);
/* harmony import */ var _components_base_ProfileImage__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(19527);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71766);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(57632);
/* harmony import */ var _libs_EventTime__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26647);




















var ref, ref1, ref2;
const getSpeakerIdentity = (speaker)=>{
    return "".concat((ref = speaker === null || speaker === void 0 ? void 0 : speaker.name) !== null && ref !== void 0 ? ref : "", "::").concat((ref2 = (ref1 = speaker === null || speaker === void 0 ? void 0 : speaker.email) !== null && ref1 !== void 0 ? ref1 : speaker === null || speaker === void 0 ? void 0 : speaker.organization) !== null && ref2 !== void 0 ? ref2 : "");
};
const SessionsForm = ()=>{
    var ref, ref1, ref2, ref3, ref4;
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false);
    const [showBreakModal, setShowBreakModal] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false);
    const [sessionModalData, setSessionModalData] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(undefined);
    const { formData , setFormData  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_10__/* .useEventEditor */ .O)();
    const { sessions , stages , event , speakers  } = formData !== null && formData !== void 0 ? formData : {};
    const noData = sessions == undefined || sessions.length === 0;
    const isInPerson = (formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_8__/* .EventType.InPerson */ .tw.InPerson;
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)();
    var ref5, ref6;
    const eventTimeZoneId = (ref6 = (ref5 = formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.timeZoneId) !== null && ref5 !== void 0 ? ref5 : (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .resolveLegacyTimeZoneId */ .N9)(formData === null || formData === void 0 ? void 0 : (ref2 = formData.event) === null || ref2 === void 0 ? void 0 : ref2.timeZone)) !== null && ref6 !== void 0 ? ref6 : (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .getBrowserTimeZoneId */ .ot)();
    const handleSubmit = async ()=>{
        if (!sessionModalData) return;
        const data = sessionModalData;
        const { title , description , startDateTime , endDateTime , stage , speakers: sessionSpeakers , editIndex , isBreak  } = data;
        let payload = {
            ...formData,
            sessions: [
                ...sessions !== null && sessions !== void 0 ? sessions : []
            ]
        };
        let newSession = {
            title: title !== null && title !== void 0 ? title : "",
            description: description !== null && description !== void 0 ? description : "",
            startDateTime: startDateTime !== null && startDateTime !== void 0 ? startDateTime : "",
            endDateTime: endDateTime !== null && endDateTime !== void 0 ? endDateTime : "",
            stage
        };
        if (isBreak) newSession.isBreak = true;
        if (!isBreak) {
            var ref;
            newSession = {
                ...newSession,
                stage: stages === null || stages === void 0 ? void 0 : stages.find((s)=>s.title === stage),
                speakers: (ref = sessionSpeakers === null || sessionSpeakers === void 0 ? void 0 : sessionSpeakers.map((s)=>{
                    return speakers === null || speakers === void 0 ? void 0 : speakers.find((es)=>{
                        if (getSpeakerIdentity(es) === s.value) return true;
                        if (es.email === s.value) return true;
                        return false;
                    });
                }).filter(Boolean)) !== null && ref !== void 0 ? ref : []
            };
        }
        if (editIndex === undefined) payload.sessions.push(newSession);
        if (editIndex !== undefined) payload.sessions[editIndex] = newSession;
        setFormData(payload);
        setHasEdited(true);
        setShowModal(false);
        setShowBreakModal(false);
    };
    var ref7, ref8;
    const breakModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        show: showBreakModal,
        setShow: setShowBreakModal,
        title: "".concat((sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.editIndex) !== undefined ? "Update" : "Add", " Break"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                required: true,
                label: "Title",
                placeholder: "Break Session Name",
                value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.title,
                onChange: (data)=>{
                    setSessionModalData({
                        ...sessionModalData,
                        title: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_5__/* .TextAreaInput */ .F, {
                className: "mt-8",
                label: "Description",
                placeholder: "Write your description",
                value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.description,
                onChange: (data)=>{
                    setSessionModalData({
                        ...sessionModalData,
                        description: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex flex-col sm:flex-row justify-between sm:space-x-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_3__/* .DateTimeInput */ .Y, {
                        timeZoneId: eventTimeZoneId,
                        required: true,
                        className: "flex-1",
                        label: "Start Date/Time",
                        initialDate: (ref7 = (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref3 = formData.event) === null || ref3 === void 0 ? void 0 : ref3.startDateTime, eventTimeZoneId)) !== null && ref7 !== void 0 ? ref7 : undefined,
                        filterDate: (rawDate)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawDate);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "day")) return false;
                            if (date.isAfter(endTime, "day")) return false;
                            return true;
                        },
                        filterTime: (rawTime)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawTime);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "minute")) return false;
                            if (date.isAfter(endTime, "minute")) return false;
                            return true;
                        },
                        value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.startDateTime,
                        onChange: (data)=>{
                            setSessionModalData({
                                ...sessionModalData,
                                startDateTime: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_3__/* .DateTimeInput */ .Y, {
                        timeZoneId: eventTimeZoneId,
                        initialDate: (ref8 = (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref4 = formData.event) === null || ref4 === void 0 ? void 0 : ref4.startDateTime, eventTimeZoneId)) !== null && ref8 !== void 0 ? ref8 : undefined,
                        required: true,
                        className: "flex-1",
                        label: "End Date/Time",
                        filterDate: (rawDate)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawDate);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "day")) return false;
                            if (date.isAfter(endTime, "day")) return false;
                            return true;
                        },
                        filterTime: (rawTime)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawTime);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "minute")) return false;
                            if (date.isAfter(endTime, "day")) return false;
                            return true;
                        },
                        value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.endDateTime,
                        onChange: (data)=>{
                            setSessionModalData({
                                ...sessionModalData,
                                endDateTime: data
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                className: "my-4",
                title: "".concat((sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.editIndex) !== undefined ? "Update" : "Add", " Break"),
                type: "primary",
                buttonType: "button",
                onClick: handleSubmit
            })
        ]
    });
    var ref9, ref10, ref11, ref12;
    const modal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        show: showModal,
        setShow: (visible)=>{
            setShowModal(visible);
        },
        title: "".concat((sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.editIndex) !== undefined ? "Update" : "Create", " Session"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_6__/* .TextInput */ .o, {
                required: true,
                label: "Title",
                placeholder: "Session Name",
                value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.title,
                onChange: (data)=>{
                    setSessionModalData({
                        ...sessionModalData,
                        title: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "mt-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ArrayTextInput__WEBPACK_IMPORTED_MODULE_15__/* .ArrayTextInput */ .M, {
                    label: "Speakers",
                    placeholder: "Speaker Name",
                    options: (ref9 = (speakers !== null && speakers !== void 0 ? speakers : []).map((s)=>{
                        return {
                            id: getSpeakerIdentity(s),
                            label: s === null || s === void 0 ? void 0 : s.name
                        };
                    })) !== null && ref9 !== void 0 ? ref9 : [],
                    value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.speakers,
                    onChange: (data)=>{
                        setSessionModalData({
                            ...sessionModalData,
                            speakers: data
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_5__/* .TextAreaInput */ .F, {
                className: "mt-6 mb-6",
                label: "Description",
                placeholder: "Write your description",
                value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.description,
                onChange: (data)=>{
                    setSessionModalData({
                        ...sessionModalData,
                        description: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex flex-col sm:flex-row justify-between sm:space-x-6 z-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_3__/* .DateTimeInput */ .Y, {
                        timeZoneId: eventTimeZoneId,
                        required: true,
                        className: "flex-1",
                        initialDate: (ref10 = (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(event === null || event === void 0 ? void 0 : event.startDateTime, eventTimeZoneId)) !== null && ref10 !== void 0 ? ref10 : undefined,
                        label: "Start Date/Time",
                        filterDate: (rawDate)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawDate);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "day")) return false;
                            if (date.isAfter(endTime, "day")) return false;
                            return true;
                        },
                        filterTime: (rawTime)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawTime);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "minute")) return false;
                            if (date.isAfter(endTime, "minute")) return false;
                            return true;
                        },
                        value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.startDateTime,
                        onChange: (data)=>{
                            setSessionModalData({
                                ...sessionModalData,
                                startDateTime: data
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DateTimeInput__WEBPACK_IMPORTED_MODULE_3__/* .DateTimeInput */ .Y, {
                        timeZoneId: eventTimeZoneId,
                        required: true,
                        validations: {
                            greaterThanDate: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.startDateTime
                        },
                        className: "flex-1",
                        initialDate: (ref11 = (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.startDateTime, eventTimeZoneId)) !== null && ref11 !== void 0 ? ref11 : undefined,
                        label: "End Date/Time",
                        filterDate: (rawDate)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawDate);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "day")) return false;
                            if (date.isAfter(endTime, "day")) return false;
                            return true;
                        },
                        filterTime: (rawTime)=>{
                            var ref, ref1;
                            const date = moment__WEBPACK_IMPORTED_MODULE_14___default()(rawTime);
                            const startTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.startDateTime, eventTimeZoneId));
                            const endTime = moment__WEBPACK_IMPORTED_MODULE_14___default()((0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .instantToPickerDate */ .qg)(formData === null || formData === void 0 ? void 0 : (ref1 = formData.event) === null || ref1 === void 0 ? void 0 : ref1.endDateTime, eventTimeZoneId));
                            if (date.isBefore(startTime, "minute")) return false;
                            if (date.isAfter(endTime, "minute")) return false;
                            return true;
                        },
                        value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.endDateTime,
                        onChange: (data)=>{
                            setSessionModalData({
                                ...sessionModalData,
                                endDateTime: data
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_4__/* .DropdownInput */ .f, {
                label: "Stage",
                options: (ref12 = stages === null || stages === void 0 ? void 0 : stages.map((s)=>s.title)) !== null && ref12 !== void 0 ? ref12 : [],
                required: !isInPerson,
                placeholder: "Select a stage",
                className: "".concat(isInPerson ? "hidden" : ""),
                value: sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.stage,
                onChange: (data)=>{
                    setSessionModalData({
                        ...sessionModalData,
                        stage: data
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                className: "my-4",
                title: "".concat((sessionModalData === null || sessionModalData === void 0 ? void 0 : sessionModalData.editIndex) !== undefined ? "Update" : "Create", " session"),
                type: "primary",
                buttonType: "button",
                onClick: ()=>{
                    setSessionModalData({
                        ...sessionModalData,
                        isBreak: false
                    });
                    handleSubmit();
                }
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            modal,
            breakModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-6 mb-4 flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setSessionModalData(undefined);
                                    setShowModal(true);
                                },
                                title: "Add Session",
                                type: "secondary",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setSessionModalData({
                                        isBreak: true
                                    });
                                    setShowBreakModal(true);
                                },
                                title: "Add Break",
                                type: "secondary",
                                size: "small",
                                className: "ml-2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Name",
                            "Start Time",
                            "End Time",
                            ...isInPerson ? [] : [
                                "Stage"
                            ],
                            "Speakers",
                            ""
                        ],
                        rows: [
                            ...sessions !== null && sessions !== void 0 ? sessions : []
                        ].map((session, originalIndex)=>({
                                session,
                                originalIndex
                            })).sort((a, b)=>{
                            const aSession = a.session;
                            const bSession = b.session;
                            if (!aSession.startDateTime || !bSession.startDateTime) return 0;
                            const aStart = moment__WEBPACK_IMPORTED_MODULE_14___default()(aSession.startDateTime);
                            const bStart = moment__WEBPACK_IMPORTED_MODULE_14___default()(bSession.startDateTime);
                            if (aStart.isAfter(bStart)) return 1;
                            if (bStart.isAfter(aStart)) return -1;
                            return 0;
                        }).map((param, index)=>{
                            let { session , originalIndex  } = param;
                            var ref, ref1;
                            return [
                                session === null || session === void 0 ? void 0 : session.title,
                                (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .formatEventInstant */ .g6)(session === null || session === void 0 ? void 0 : session.startDateTime, "MMM DD, h:mmA", formData === null || formData === void 0 ? void 0 : formData.event),
                                (0,_libs_EventTime__WEBPACK_IMPORTED_MODULE_18__/* .formatEventInstant */ .g6)(session === null || session === void 0 ? void 0 : session.endDateTime, "MMM DD, h:mmA", formData === null || formData === void 0 ? void 0 : formData.event),
                                !(session === null || session === void 0 ? void 0 : session.isBreak) ? session === null || session === void 0 ? void 0 : (ref = session.stage) === null || ref === void 0 ? void 0 : ref.title : "Break",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "flex -space-x-5 flex-wrap",
                                    children: session === null || session === void 0 ? void 0 : (ref1 = session.speakers) === null || ref1 === void 0 ? void 0 : ref1.map((s)=>{
                                        var ref, ref1;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_ProfileImage__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            imageUrl: (ref = s === null || s === void 0 ? void 0 : s.profileImage) !== null && ref !== void 0 ? ref : null
                                        }, (ref1 = s === null || s === void 0 ? void 0 : s.email) !== null && ref1 !== void 0 ? ref1 : (0,uuid__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)());
                                    })
                                }, index),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    confirmModal: {
                                        title: "Are you sure?",
                                        content: "Are you sure you want to delete this? This cannot be undone."
                                    },
                                    editClicked: ()=>{
                                        var ref, ref1;
                                        setSessionModalData({
                                            title: session === null || session === void 0 ? void 0 : session.title,
                                            description: session === null || session === void 0 ? void 0 : session.description,
                                            startDateTime: session === null || session === void 0 ? void 0 : session.startDateTime,
                                            endDateTime: session === null || session === void 0 ? void 0 : session.endDateTime,
                                            stage: session === null || session === void 0 ? void 0 : (ref = session.stage) === null || ref === void 0 ? void 0 : ref.title,
                                            speakers: session === null || session === void 0 ? void 0 : (ref1 = session.speakers) === null || ref1 === void 0 ? void 0 : ref1.map((s)=>{
                                                return {
                                                    key: s === null || s === void 0 ? void 0 : s.name,
                                                    value: getSpeakerIdentity(s)
                                                };
                                            }),
                                            editIndex: originalIndex,
                                            isBreak: session === null || session === void 0 ? void 0 : session.isBreak
                                        });
                                        if (session === null || session === void 0 ? void 0 : session.isBreak) setShowBreakModal(true);
                                        if (!(session === null || session === void 0 ? void 0 : session.isBreak)) setShowModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        setHasEdited(true);
                                        setFormData({
                                            ...formData,
                                            sessions: sessions === null || sessions === void 0 ? void 0 : sessions.filter((_, i)=>i !== originalIndex)
                                        });
                                    }
                                }, index)
                            ];
                        })
                    }),
                    noData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mt-8 text-center",
                                children: "No sessions have been created"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SessionsForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (SessionsForm);


/***/ }),

/***/ 54212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40296);
/* harmony import */ var _components_inputs_Form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26291);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18860);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68240);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25687);
/* harmony import */ var _libs_useFileUploader__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29033);
/* harmony import */ var react_papaparse__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16798);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(71766);
/* harmony import */ var _components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33923);
/* harmony import */ var _libs_Utility_util__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52229);


















const SpeakersForm = ()=>{
    var ref;
    const [showSpeakerModal, setShowSpeakerModal] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false);
    const [showImportModal, setShowImportModal] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(false);
    const { formData , setFormData , errors , setErrors  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__/* .useEventEditor */ .O)();
    const { speakers  } = formData !== null && formData !== void 0 ? formData : {};
    const noSpeakers = speakers == undefined || (speakers === null || speakers === void 0 ? void 0 : speakers.length) === 0;
    const uploadFile = (0,_libs_useFileUploader__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    const { readRemoteFile  } = (0,react_papaparse__WEBPACK_IMPORTED_MODULE_14__/* .usePapaParse */ .vE)();
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)();
    const [speakerModalData, setSpeakerModalData] = (0,react__WEBPACK_IMPORTED_MODULE_11__.useState)(undefined);
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    const addSpeakerModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        show: showSpeakerModal,
        setShow: setShowSpeakerModal,
        title: "Add Speaker",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l, {
            initialFormData: {
                name: (ref1 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.name) !== null && ref1 !== void 0 ? ref1 : "",
                email: (ref2 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.email) !== null && ref2 !== void 0 ? ref2 : "",
                position: (ref3 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.position) !== null && ref3 !== void 0 ? ref3 : "",
                organisation: (ref4 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.organization) !== null && ref4 !== void 0 ? ref4 : "",
                profileImage: (ref5 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.profileImage) !== null && ref5 !== void 0 ? ref5 : "https://media.istockphoto.com/vectors/male-user-icon-vector-id517998264?k=20&m=517998264&s=612x612&w=0&h=pdEwtkJlZsIoYBVeO2Bo4jJN6lxOuifgjaH8uMIaHTU=",
                TicketType: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .TicketType.Free */ .zK.Free,
                bio: (ref6 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.bio) !== null && ref6 !== void 0 ? ref6 : "",
                editIndex: (ref7 = speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.editIndex) !== null && ref7 !== void 0 ? ref7 : ""
            },
            onSubmit: async (data)=>{
                const { name , email , position , organisation , profileImage , ticketType , bio , editIndex  } = data;
                const speakerData = {
                    name,
                    email,
                    position,
                    organization: organisation,
                    profileImage,
                    ticketType,
                    bio
                };
                var ref;
                const payload = [
                    ...(ref = formData === null || formData === void 0 ? void 0 : formData.speakers) !== null && ref !== void 0 ? ref : []
                ];
                if (editIndex || editIndex === 0) payload[editIndex] = speakerData;
                else payload.push(speakerData);
                setFormData({
                    ...formData,
                    speakers: payload
                });
                setSpeakerModalData(undefined);
                setShowSpeakerModal(false);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex justify-center p-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_3__/* .FileInput */ .S, {
                        uploadFile: uploadFile,
                        label: "Profile Image",
                        hint: "(Optional) recommended size 800x800px",
                        hintPosition: "bottom",
                        value: speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.profileImage,
                        crop: true,
                        cropShape: "rect",
                        cropAspectRatio: 1
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex gap-2 flex-wrap",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                            className: "flex-1",
                            validations: {
                                maxLength: {
                                    value: 70,
                                    message: "Name must be at most 70 characters"
                                }
                            },
                            required: true,
                            setError: errorHandler("speakers"),
                            label: "Name",
                            placeholder: "Taylor Swift",
                            value: speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.name
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                            className: "flex-2",
                            validations: {
                                minLength: {
                                    value: 7,
                                    message: "Email must be at least 7 characters"
                                },
                                maxLength: {
                                    value: 70,
                                    message: "Email must be less than 70 characters"
                                },
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Email must be valid"
                                }
                            },
                            type: "email",
                            label: "Email",
                            required: (formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.eventType) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .EventType.Online */ .tw.Online,
                            placeholder: "tswift@mail.com",
                            setError: errorHandler("speakers"),
                            value: speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.email
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "flex flex-wrap gap-2",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                            className: "flex-1 mt-2",
                            validations: {
                                maxLength: {
                                    value: 70,
                                    message: "Position must be less than 70 characters"
                                }
                            },
                            required: true,
                            label: "Position",
                            setError: errorHandler("speakers"),
                            placeholder: "Manager",
                            value: speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.position
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                            className: "flex-1 mt-2",
                            validations: {
                                maxLength: {
                                    value: 70,
                                    message: "Organisation must be less than 70 characters"
                                }
                            },
                            required: true,
                            label: "Organisation",
                            setError: errorHandler("speakers"),
                            placeholder: "Forumm",
                            value: speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.organization
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_16__/* .TextAreaInput */ .F, {
                    className: "mt-2",
                    testid: "speaker-bio-input",
                    validations: {
                        maxLength: {
                            value: 1000,
                            message: "Speakers bio must be 1000 characters or less"
                        }
                    },
                    required: true,
                    hint: "(Maximum of 1000 characters)",
                    label: "Bio",
                    setError: errorHandler("speakers"),
                    placeholder: "A short bio about the speaker",
                    value: speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.bio
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    className: "text-sm",
                    children: "Once you've published your event, your speakers will receive an invite email."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                    className: "my-4 ml-auto",
                    title: "".concat((speakerModalData === null || speakerModalData === void 0 ? void 0 : speakerModalData.name) ? "Save" : "Add", " Speaker"),
                    type: "primary",
                    buttonType: "submit"
                })
            ]
        })
    });
    const importCSVModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        show: showImportModal,
        setShow: setShowImportModal,
        title: "Import Speaker from CSV",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "https://forumm-images-prod.s3.eu-west-1.amazonaws.com/user-content/manual-upload/sample_speakers.csv",
                className: "text-link hover:underline pointer",
                download: true,
                children: "Download Sample CSV"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l, {
                clearFormOnSubmit: true,
                onSubmit: async (data)=>{
                    const { csvUpload , ticket  } = data;
                    readRemoteFile(csvUpload, {
                        download: true,
                        complete: (res)=>{
                            const newSpeakers = [];
                            const emailHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "email";
                            });
                            const nameHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "name" || h.toLowerCase() === "fullname";
                            });
                            const organisationHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "organisation" || h.toLowerCase() === "organization";
                            });
                            const positionHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "position";
                            });
                            const profileImageHeaderIndex = res.data[0].findIndex((h)=>{
                                return h.toLowerCase() === "profileimage" || h.toLowerCase() === "image" || h.toLowerCase() === "pfp" || h.toLowerCase() === "avatar";
                            });
                            if (emailHeaderIndex !== -1) res.data.forEach((newA)=>{
                                if (!newA[emailHeaderIndex]) return;
                                const emailRef = newA[emailHeaderIndex].toLowerCase();
                                var _nameHeaderIndex;
                                const nameRef = (_nameHeaderIndex = newA[nameHeaderIndex]) !== null && _nameHeaderIndex !== void 0 ? _nameHeaderIndex : "No name on file";
                                var _organisationHeaderIndex;
                                const organisationRef = (_organisationHeaderIndex = newA[organisationHeaderIndex]) !== null && _organisationHeaderIndex !== void 0 ? _organisationHeaderIndex : "No organisation on file";
                                var _positionHeaderIndex;
                                const positionRef = (_positionHeaderIndex = newA[positionHeaderIndex]) !== null && _positionHeaderIndex !== void 0 ? _positionHeaderIndex : "No position on file";
                                var _profileImageHeaderIndex;
                                const profileImageRef = (_profileImageHeaderIndex = newA[profileImageHeaderIndex]) !== null && _profileImageHeaderIndex !== void 0 ? _profileImageHeaderIndex : "https://media.istockphoto.com/vectors/male-user-icon-vector-id517998264?k=20&m=517998264&s=612x612&w=0&h=pdEwtkJlZsIoYBVeO2Bo4jJN6lxOuifgjaH8uMIaHTU=";
                                if (speakers === null || speakers === void 0 ? void 0 : speakers.find((a)=>a.email === emailRef)) return;
                                if (emailRef === "email") return;
                                newSpeakers.push({
                                    name: nameRef,
                                    email: emailRef,
                                    ticketType: "FREE",
                                    organization: organisationRef,
                                    position: positionRef,
                                    profileImage: profileImageRef
                                });
                            });
                            setFormData({
                                ...formData,
                                speakers: [
                                    ...speakers !== null && speakers !== void 0 ? speakers : [],
                                    ...newSpeakers !== null && newSpeakers !== void 0 ? newSpeakers : []
                                ]
                            });
                            setHasEdited(true);
                            setShowImportModal(false);
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_3__/* .FileInput */ .S, {
                        uploadFile: uploadFile,
                        className: "mt-1",
                        label: "CSV Upload",
                        hint: "Max upload: (200MB).",
                        type: "csv"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        className: "my-4",
                        title: "Import Speakers",
                        type: "primary",
                        buttonType: "submit"
                    })
                ]
            })
        ]
    });
    var ref8;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            importCSVModal,
            addSpeakerModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-6 mb-4 flex",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setSpeakerModalData(undefined);
                                    setShowSpeakerModal(true);
                                },
                                title: "Add Speaker",
                                type: "secondary",
                                size: "small",
                                className: "mr-4"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                onClick: ()=>{
                                    setShowImportModal(true);
                                },
                                title: "Import Speakers",
                                type: "secondary",
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Name",
                            "Email",
                            "Postion",
                            "Organization",
                            ""
                        ],
                        rows: speakers === null || speakers === void 0 ? void 0 : speakers.map((speaker, index)=>{
                            return [
                                speaker === null || speaker === void 0 ? void 0 : speaker.name,
                                (ref8 = (0,_libs_Utility_util__WEBPACK_IMPORTED_MODULE_17__/* .truncateString */ .aS)(speaker === null || speaker === void 0 ? void 0 : speaker.email, 200)) !== null && ref8 !== void 0 ? ref8 : "No email on file",
                                speaker === null || speaker === void 0 ? void 0 : speaker.position,
                                speaker === null || speaker === void 0 ? void 0 : speaker.organization,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    confirmModal: {
                                        title: "Are you sure?",
                                        content: "Are you sure you want to delete this? This cannot be undone."
                                    },
                                    editClicked: ()=>{
                                        var ref, ref1;
                                        const modalData = {
                                            name: speaker === null || speaker === void 0 ? void 0 : speaker.name,
                                            email: speaker === null || speaker === void 0 ? void 0 : speaker.email,
                                            position: speaker === null || speaker === void 0 ? void 0 : speaker.position,
                                            organization: speaker === null || speaker === void 0 ? void 0 : speaker.organization,
                                            profileImage: (ref = speaker === null || speaker === void 0 ? void 0 : speaker.profileImage) !== null && ref !== void 0 ? ref : "",
                                            bio: (ref1 = speaker === null || speaker === void 0 ? void 0 : speaker.bio) !== null && ref1 !== void 0 ? ref1 : "",
                                            editIndex: index
                                        };
                                        setSpeakerModalData(modalData);
                                        setShowSpeakerModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        setHasEdited(true);
                                        setFormData({
                                            ...formData,
                                            speakers: speakers.filter((_, i)=>i !== index)
                                        });
                                    }
                                }, index)
                            ];
                        })
                    }),
                    noSpeakers && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mt-8 text-center",
                                children: "No speakers have been created"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SpeakersForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (SpeakersForm);


/***/ }),

/***/ 10942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33923);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18860);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45672);
/* harmony import */ var _components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40296);
/* harmony import */ var _libs_useFileUploader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11734);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57632);
/* harmony import */ var _libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40654);
/* harmony import */ var _components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20970);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(71766);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(8193);
/* harmony import */ var _components_ui_MediaThumbnail__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26052);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5434);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(79352);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5779);
/* harmony import */ var _components_inputs_Form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26291);






















const SponsorsForm = ()=>{
    const [modalStage, setModalStage] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("details");
    const [showModal, setShowModal] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(false);
    const [mediaType, setMediaType] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)("upload");
    const { formData , setFormData , errors , setErrors  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_7__/* .useEventEditor */ .O)();
    const { sponsors  } = formData !== null && formData !== void 0 ? formData : {};
    const noData = sponsors == undefined || sponsors.length === 0;
    const uploadFile = (0,_libs_useFileUploader__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
    const { StaticColours  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_16__/* .useTheme */ .Fg)();
    const [sponsorModalData, setSponsorModalData] = (0,react__WEBPACK_IMPORTED_MODULE_8__.useState)(undefined);
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const modal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        show: showModal,
        setShow: (val)=>{
            setShowModal(val);
            setModalStage("details");
        },
        title: "".concat((sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.editIndex) !== undefined ? "Update" : "Add", " Partner"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_17__/* .Form */ .l, {
            initialFormData: {
                title: (ref = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.title) !== null && ref !== void 0 ? ref : "",
                websiteUrl: (ref1 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.websiteUrl) !== null && ref1 !== void 0 ? ref1 : "",
                logoUpload: (ref2 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.logoUpload) !== null && ref2 !== void 0 ? ref2 : "",
                description: (ref3 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.description) !== null && ref3 !== void 0 ? ref3 : "",
                facebookUrl: (ref4 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.facebookUrl) !== null && ref4 !== void 0 ? ref4 : "",
                twitterUrl: (ref5 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.twitterUrl) !== null && ref5 !== void 0 ? ref5 : "",
                linkedinUrl: (ref6 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.linkedinUrl) !== null && ref6 !== void 0 ? ref6 : "",
                mediaTitle: (ref7 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.mediaTitle) !== null && ref7 !== void 0 ? ref7 : "",
                mediaDescription: (ref8 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.mediaDescription) !== null && ref8 !== void 0 ? ref8 : "",
                mediaInput: (ref9 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.mediaInput) !== null && ref9 !== void 0 ? ref9 : "",
                externalMediaUrl: (ref10 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.externalMediaUrl) !== null && ref10 !== void 0 ? ref10 : "",
                mediaId: (ref11 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.mediaId) !== null && ref11 !== void 0 ? ref11 : "",
                editIndex: (ref12 = sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.editIndex) !== null && ref12 !== void 0 ? ref12 : ""
            },
            onSubmit: async (data)=>{
                const { title , websiteUrl , logoUpload , description , facebookUrl , twitterUrl , linkedinUrl , mediaTitle , mediaDescription , mediaInput , externalMediaUrl , mediaId , editIndex  } = data;
                let payload = {
                    ...formData,
                    sponsors: [
                        ...sponsors !== null && sponsors !== void 0 ? sponsors : []
                    ]
                };
                const newSponsor = {
                    title: title !== null && title !== void 0 ? title : "Partner ".concat(payload.sponsors.length + 1),
                    websiteUrl: websiteUrl !== null && websiteUrl !== void 0 ? websiteUrl : null,
                    logoUrl: logoUpload !== null && logoUpload !== void 0 ? logoUpload : null,
                    description: description !== null && description !== void 0 ? description : null,
                    facebookUrl: facebookUrl !== null && facebookUrl !== void 0 ? facebookUrl : null,
                    twitterUrl: twitterUrl !== null && twitterUrl !== void 0 ? twitterUrl : null,
                    linkedinUrl: linkedinUrl !== null && linkedinUrl !== void 0 ? linkedinUrl : null,
                    ondemandContent: externalMediaUrl || mediaInput ? [
                        {
                            id: mediaId !== null && mediaId !== void 0 ? mediaId : (0,uuid__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(),
                            title: mediaTitle !== null && mediaTitle !== void 0 ? mediaTitle : "Default Media Title",
                            description: mediaDescription !== null && mediaDescription !== void 0 ? mediaDescription : "Default Media Description",
                            url: mediaType === "url" ? externalMediaUrl : mediaInput
                        }
                    ] : null
                };
                // console.log({ data, paylod: payload.sponsors, newSponsor })
                if (editIndex || editIndex === 0) payload.sponsors[editIndex] = newSponsor;
                else payload.sponsors.push(newSponsor);
                setFormData(payload);
                setHasEdited(true);
                setShowModal(false);
                setModalStage("details");
                setSponsorModalData(undefined);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    show: modalStage === "details",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            label: "Title",
                            placeholder: "Forumm",
                            className: "mb-2",
                            required: true,
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S, {
                            uploadFile: uploadFile,
                            label: "Logo Upload",
                            hint: "(Optional) recommended size 500x500px",
                            // value={sponsorModalData?.logoUpload ?? sponsorModalData?.logoUrl}
                            className: "mt-5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            label: "Website Url",
                            placeholder: "https://forumm.events/",
                            // value={sponsorModalData?.websiteUrl}
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_3__/* .TextAreaInput */ .F, {
                            className: "mt-6",
                            label: "Description",
                            placeholder: "Write your description",
                            // value={sponsorModalData?.description}
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            label: "Facebook Url",
                            placeholder: "https://facebook.com/..",
                            // value={sponsorModalData?.facebookUrl}
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            label: "Twitter Url",
                            placeholder: "https://twitter.com/..",
                            // value={sponsorModalData?.twitterUrl}
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            label: "Linkedin Url",
                            placeholder: "https://linkedin.com/..",
                            // value={sponsorModalData?.linkedinUrl}
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            className: "my-4 ml-auto",
                            // title={sponsorModalData?.editIndex !== undefined ? 'Update' : 'Add'}
                            title: "Next",
                            type: "primary",
                            buttonType: "button",
                            // onClick={handleSubmitModal}
                            onClick: ()=>setModalStage("media")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    show: modalStage === "media",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_ToggleInput__WEBPACK_IMPORTED_MODULE_13__/* .ToggleInput */ .s, {
                            className: "my-2",
                            options: [
                                "Upload",
                                "URL"
                            ],
                            callback: (val)=>{
                                setMediaType(val.toLowerCase());
                            },
                            label: "Media Type",
                            selected: mediaType === "url" ? 1 : 0
                        }),
                        mediaType === "upload" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_FileInput__WEBPACK_IMPORTED_MODULE_10__/* .FileInput */ .S, {
                            className: "mt-8",
                            uploadFile: uploadFile,
                            label: "Media Input",
                            hint: "Max upload: (200MB)."
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            validations: {
                                isURL: true
                            },
                            label: "External Media Url",
                            placeholder: "https://youtube.com/...",
                            value: sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.externalMediaUrl,
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            validations: {
                                minLength: {
                                    value: 2,
                                    message: "Media title must be at least 2 character"
                                }
                            },
                            label: "Media Title",
                            placeholder: "Content title",
                            // value={sponsorModalData?.mediaTitle}
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_4__/* .TextInput */ .o, {
                            validations: {
                                minLength: {
                                    value: 2,
                                    message: "Media description must be at least 2 character"
                                }
                            },
                            label: "Media Description",
                            placeholder: "Content description",
                            setError: errorHandler("sponsors")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                            className: "flex flex-row w-full justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                    className: "my-4",
                                    title: "Back",
                                    type: "primary",
                                    buttonType: "button",
                                    onClick: ()=>setModalStage("details")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                    className: "my-4",
                                    title: "".concat((sponsorModalData === null || sponsorModalData === void 0 ? void 0 : sponsorModalData.editIndex) !== undefined ? "Update" : "Add", " Partner"),
                                    type: "primary",
                                    buttonType: "submit"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            modal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-6 mb-4 flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            onClick: ()=>{
                                setModalStage("details");
                                setSponsorModalData(undefined);
                                setShowModal(true);
                            },
                            title: "Add Partner",
                            type: "secondary",
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        tableHeading: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_19__/* .MdOutlineImage */ .Fwj, {
                                className: "mx-auto"
                            }, "LogoHeader"),
                            "Partner Name",
                            "Socials",
                            "Media",
                            ""
                        ],
                        rows: sponsors === null || sponsors === void 0 ? void 0 : sponsors.map((sponsor, index)=>{
                            var ref;
                            return [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MediaThumbnail__WEBPACK_IMPORTED_MODULE_15__/* .MediaThumbnail */ .U, {
                                    media: sponsor.logoUrl,
                                    className: "mx-auto rounded"
                                }, "partner-media-key-".concat(index)),
                                sponsor.title,
                                sponsor.twitterUrl || sponsor.facebookUrl || sponsor.linkedinUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_20__/* .AiOutlineCheck */ .bzc, {
                                    className: "inline-block h-4 w-4 ml-4"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_20__/* .AiOutlineClose */ .oHP, {
                                    className: "inline-block h-4 w-4 ml-4 fill-red"
                                }),
                                sponsor.ondemandContent && ((ref = sponsor.ondemandContent) === null || ref === void 0 ? void 0 : ref.length) > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_20__/* .AiOutlineCheck */ .bzc, {
                                    className: "inline-block h-4 w-4 ml-4"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_20__/* .AiOutlineClose */ .oHP, {
                                    className: "inline-block h-4 w-4 ml-4 fill-red"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                            onClick: ()=>{
                                                const odc = sponsor.ondemandContent && sponsor.ondemandContent.length > 0 ? sponsor.ondemandContent[0] : false;
                                                const isYoutube = odc && (0,_libs_Utility_parsers__WEBPACK_IMPORTED_MODULE_12__/* .isYoutubeUrl */ .Qd)(odc.url);
                                                var _logoUrl;
                                                const initData = {
                                                    ...sponsor,
                                                    mediaTitle: odc && odc.title ? odc.title : "",
                                                    mediaDescription: odc && odc.description ? odc.description : "",
                                                    mediaInput: odc && !isYoutube && odc.url ? odc.url : undefined,
                                                    externalMediaUrl: isYoutube && odc.url ? odc.url : undefined,
                                                    logoUpload: (_logoUrl = sponsor.logoUrl) !== null && _logoUrl !== void 0 ? _logoUrl : "",
                                                    mediaId: odc ? odc.id : "",
                                                    editIndex: index
                                                };
                                                setMediaType(isYoutube ? "url" : "upload");
                                                setSponsorModalData(initData);
                                                setModalStage("details");
                                                setShowModal(true);
                                            },
                                            className: "ml-auto mr-2",
                                            type: "secondary",
                                            size: "small",
                                            title: "Edit"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                                            confirmationModal: {
                                                title: "Are you sure?",
                                                content: "Are you sure you want to delete this? This cannot be undone."
                                            },
                                            onClick: ()=>{
                                                setHasEdited(true);
                                                setFormData({
                                                    ...formData,
                                                    sponsors: sponsors.filter((_, i)=>i !== index)
                                                });
                                            },
                                            className: "mr-2",
                                            type: "danger",
                                            size: "small",
                                            // title="Remove"
                                            iconColor: StaticColours.forumm_red,
                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_21__/* .RiDeleteBinLine */ .qy0, {})
                                        }, index)
                                    ]
                                }, index)
                            ];
                        })
                    }),
                    noData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mt-8 text-center",
                                children: "No partners have been created"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
SponsorsForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (SponsorsForm);


/***/ }),

/***/ 23906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var _components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11390);
/* harmony import */ var _components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61993);
/* harmony import */ var _components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33923);
/* harmony import */ var _components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39618);
/* harmony import */ var _components_base_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18860);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68240);
/* harmony import */ var _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67526);
/* harmony import */ var _libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var _components_base_Table__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45672);
/* harmony import */ var _components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29033);
/* harmony import */ var _libs_useAutosave__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71766);
/* harmony import */ var _components_inputs_Form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26291);















const StagesForm = ()=>{
    const [showStageModal, setShowStageModal] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [modalData, setModalData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)();
    const { formData , setFormData , errors , setErrors  } = (0,_libs_CreateEvent_useEventEditor__WEBPACK_IMPORTED_MODULE_9__/* .useEventEditor */ .O)();
    const { stages  } = formData !== null && formData !== void 0 ? formData : {};
    const noStages = stages == undefined || stages.length === 0;
    const { setHasEdited  } = (0,_libs_useAutosave__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)();
    const [stageModalData, setStageModalData] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(undefined);
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    var ref, ref1, ref2, ref3;
    const addStageModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        show: showStageModal,
        setShow: (visible)=>{
            if (!visible) {
                setStageModalData(undefined);
            }
            setShowStageModal(visible);
        },
        title: "".concat((modalData === null || modalData === void 0 ? void 0 : modalData.editIndex) !== undefined ? "Update" : "Create", " Stage"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_inputs_Form__WEBPACK_IMPORTED_MODULE_14__/* .Form */ .l, {
            initialFormData: {
                title: (ref = stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.title) !== null && ref !== void 0 ? ref : "",
                description: (ref1 = stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.description) !== null && ref1 !== void 0 ? ref1 : "",
                holdingVideoUrl: (ref2 = stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.holdingVideoUrl) !== null && ref2 !== void 0 ? ref2 : "",
                stageType: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .StageType.Internal */ .$b.Internal,
                editIndex: (ref3 = stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.editIndex) !== null && ref3 !== void 0 ? ref3 : ""
            },
            onSubmit: async (data)=>{
                const { title , description , holdingVideoUrl , stageType , editIndex  } = data;
                let payload = {
                    ...formData,
                    stages: [
                        ...stages !== null && stages !== void 0 ? stages : []
                    ]
                };
                const newStage = {
                    title: title !== null && title !== void 0 ? title : "",
                    class: stageType,
                    ...description && {
                        description: description
                    },
                    ...holdingVideoUrl && {
                        holdingVideoUrl: holdingVideoUrl
                    }
                };
                if (editIndex || editIndex === 0) payload.stages[editIndex] = newStage;
                else payload.stages.push(newStage);
                setFormData(payload);
                setStageModalData(undefined);
                setHasEdited(true);
                setShowStageModal(false);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                    required: true,
                    label: "Title",
                    placeholder: "Stage Name",
                    value: stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.title,
                    setError: errorHandler("stages")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextAreaInput__WEBPACK_IMPORTED_MODULE_4__/* .TextAreaInput */ .F, {
                    className: "mt-8",
                    label: "Description",
                    placeholder: "Write your description",
                    value: stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.description,
                    setError: errorHandler("stages")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_DropdownInput__WEBPACK_IMPORTED_MODULE_3__/* .DropdownInput */ .f, {
                    label: "Stage Type",
                    required: true,
                    value: stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.class,
                    onChange: (data)=>{
                        setStageModalData({
                            ...stageModalData,
                            class: data
                        });
                    },
                    options: [
                        {
                            label: "Hosted by 3rd Party",
                            value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .StageType.External */ .$b.External
                        },
                        {
                            label: "Hosted on Forumm",
                            value: _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .StageType.Internal */ .$b.Internal
                        }
                    ],
                    placeholder: "Select stage type"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_TextInput__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, {
                    validations: {
                        isURL: true
                    },
                    label: (stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.class) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_7__/* .StageType.External */ .$b.External ? "Live Video Url" : "Holding Video Url",
                    placeholder: "https://www.youtube.com/...",
                    value: stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.holdingVideoUrl,
                    setError: errorHandler("stages")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                    className: "my-4",
                    title: "".concat((stageModalData === null || stageModalData === void 0 ? void 0 : stageModalData.editIndex) !== undefined ? "Update" : "Create", " Stage"),
                    type: "primary",
                    buttonType: "submit"
                })
            ]
        })
    });
    var _description, _holdingVideoUrl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            addStageModal,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        className: "mt-6 mb-4 flex",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_inputs_Button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                            onClick: ()=>{
                                setShowStageModal(true);
                                setModalData(undefined);
                            },
                            title: "Add Stage",
                            type: "secondary",
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Table__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        tableHeading: [
                            "Title",
                            "Description",
                            "Holding Video",
                            ""
                        ],
                        rows: stages === null || stages === void 0 ? void 0 : stages.map((stage, index)=>[
                                stage.title,
                                (_description = stage.description) !== null && _description !== void 0 ? _description : "",
                                (_holdingVideoUrl = stage.holdingVideoUrl) !== null && _holdingVideoUrl !== void 0 ? _holdingVideoUrl : "",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_TableRowActions__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    confirmModal: {
                                        title: "Are you sure?",
                                        content: "Are you sure you want to delete this? This cannot be undone."
                                    },
                                    editClicked: ()=>{
                                        setStageModalData({
                                            title: stage.title,
                                            editIndex: index,
                                            class: stage.class,
                                            ...stage.description && {
                                                description: stage.description
                                            },
                                            ...stage.holdingVideoUrl && {
                                                holdingVideoUrl: stage.holdingVideoUrl
                                            }
                                        });
                                        setShowStageModal(true);
                                    },
                                    deleteClicked: ()=>{
                                        setHasEdited(true);
                                        setFormData({
                                            ...formData,
                                            stages: stages.filter((s)=>s.title !== stage.title)
                                        });
                                    }
                                }, index)
                            ])
                    }),
                    noStages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                className: "text-sm mt-8 text-center",
                                children: "No stages have been created"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                className: "my-6 border-gray-600 opacity-50"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
StagesForm.Layout = _layouts_CreateEventLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["default"] = (StagesForm);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,3777,3714,9401,1458,9198,474,4555,1209,7632,9681,6109,9041,8012,9265,9226,4893,788,5687,7526,7585,4904,1433,5250,9774,2888,179], function() { return __webpack_exec__(52447); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);